import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import {
  ConfirmationService,
  MenuItem,
  MessageService,
  PrimeIcons,
  TranslationKeys,
} from "primeng/api";
import { NGXLogger } from "ngx-logger";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ActivatedRoute, Router } from "@angular/router";
import { OdaAtFirestore } from "src/app/models/odaAtFirestore.model";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { environment } from "src/environments/environment";
import { onSnapshot } from "firebase/firestore";
import { UtilService } from "src/app/services/util.service";
import { Menu } from "primeng/menu";
import { v4 as uuidv4 } from "uuid";
import { ExcelService } from "src/app/services/excelService.service";
import {
  FiltroPratica,
  PraticaFlowdy2_Firestore,
} from "src/app/models/praticaFirestore.model";
import { StiliService } from "src/app/services/stili.service";
import { UtentiService } from "src/app/services/utenti.service";
import { UserService } from "src/app/services/user.service";
import {
  deleteObject,
  getBlob,
  getStorage,
  listAll,
  ref,
} from "firebase/storage";
import { saveAs } from "file-saver";
import { PraticheService } from "src/app/services/pratiche.service";
import { DialogNoteRework } from "../../../scuola/bando2/pratiche-scuola-bando2.component";
import * as JSZip from "jszip";
import { Location } from "@angular/common";
import { th } from "date-fns/locale";
import { Utente } from "src/app/models/utente.model";
import { DialogAssegnaOdaFase1 } from "../../shared/assegna-oda/assegna-oda.component";
import { OdaService } from "src/app/services/oda.service";
import { StoricoPraticaComponent } from "../../shared/storico/storico-pratica.component";
import { DialogEsitoSopralluogoFase1 } from "../../shared/esito-sopralluogo-fase1/esito-sopralluogo.component";
import { DialogModificaPreventivoFase1 } from "../../shared/modifica-preventivo/modifica-preventivo.component";
import { DialogCaricaPreventivoFase1 } from "../../shared/carica-preventivo/carica-preventivo.component";
import { DialogCaricaDocumentoFase1 } from "../../shared/carica-documento/carica-documento.component";
import { DialogVerificaConsegnaFase1 } from "../../shared/verifica-consegna-fase1/verifica-consegna.component";
import { DialogRifiutaPreventivoFase1 } from "../../shared/rifiuta-preventivo/rifiuta-preventivo.component";
import { DialogNoteReworkFase1 } from "../../shared/note-rework-fase1/note-rework.component";
import { ComunicaBocciatura } from "../../shared/comunica-bocciatura/comunica_bocciatura.component";
import { DialogAccettazioneInvioInfratel } from "../../shared/comunica-accettazione/accettazione.component";
import { DialogInvioInfratel } from "../../shared/comunica-invio-infratel/invio-infratel.component";
import { DialogPresidioTIMRifiutaPratica } from "../../shared/presidioTIM-rifiuta-pratica/presidioTIM_rifiuta_pratica.component";
import { ListeService } from "src/app/services/liste.service";
import { Impresa } from "src/app/models/impresa.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { DialogNoteImpresa } from "../../shared/note-impresa/note-impresa.component";
import { DialogModificaStato } from "../../shared/modifica-stato/modifica_stato.component";
import { DialogComunicaDataSopralluogoFase1 } from "../../shared/data-sopralluogo-fase1/data_sopralluogo_fase1.component";
import { StoricoNotePraticaComponent } from "../../shared/note-pratica/note-pratica.component";
import { CreaNotaPraticaComponent } from "../../shared/crea-note-pratica/crea-nota-pratica.component";
import { MagazzinoService } from "src/app/services/magazzino.service";

declare const CSVBoxImporter: any;

@Component({
  templateUrl: "./fase1.bando2.component.html",
  styleUrls: ["./fase1.bando2.component.css"],
  providers: [DialogService, ConfirmationService],
})
export class PraticheFase1Bando2Component implements OnInit, OnDestroy {
  protected isLoadingResults: boolean = false;
  protected mostraPraticheCompletate: boolean = false;
  protected mostraPreventiviApprovati: boolean = false;
  private importID: string;

  protected showDeliverConfirmation: boolean = false;
  protected showAnnullaConsegnaConfirmation: boolean = false;
  protected showConfermaPreventivo: boolean = false;
  protected showResettaPratica: boolean = false;
  protected showFase1Approvata: boolean = false;
  protected showDettagliPratica: boolean = false;
  protected showDeletePraticaConfirmation: boolean = false;

  public isAdmin: boolean = false;
  public isSuperAdmin: boolean = false;
  public isPresidioSF: boolean = false;
  public isPresidioTIM: boolean = false;
  public isDirigenteFirmaVerbali: boolean = false;
  public isDirigenteFirmaPacchetti: boolean = false;
  public isPM: boolean = false;
  public isContabile: boolean = false;
  public isImpresa: boolean = false;
  public isDemo: boolean = false;

  protected pratiche: PraticaFlowdy2_Firestore[];
  protected praticheSenzaEscludereLeKO: PraticaFlowdy2_Firestore[];

  protected praticheFiltrate: PraticaFlowdy2_Firestore[];
  protected selectedPratica: PraticaFlowdy2_Firestore;

  @ViewChild("menuAzioni", { static: true }) azioniMenu: Menu;
  @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered: Menu;

  protected menuAzioniItems!: MenuItem[];

  private collection_pratiche: string =
    environment.firebase.collection_pratiche;

  private ref: DynamicDialogRef;

  protected filterTabellaIsSet: boolean = false;
  protected filterIsSet: boolean = false;
  protected filtroInLavorazione: boolean = false;
  protected filtroLotto: String;
  protected filtroStatoInfratel: String;
  protected filtroOda: String;
  protected filtroDaPagare: boolean = false;
  protected filtroLottoPerFase: String;

  protected filtroImpresa: String;
  protected ragioneSocialeImpresa: String = "";
  protected statoSopralluogo: String = "";
  protected filtroStatoSopralluogo: String;
  protected filtroRegione: String;

  protected filtroStatoFlowdy: String;
  protected paginaBack: string = null;

  protected filtroPratica: String;

  private csvbox_licenseKey_comunicaEsitiConsegnaBando2: string =
    environment.csvBox.secret_comunicaEsitiConsegnaFase1;
  private csvbox_importer_comunicaEsitiConsegnaBando2: any;

  private _filtroPratiche!: FiltroPratica;

  protected imprese: Impresa[] = [];

  protected filtroTipoSedeEffettivaSop: String;

  get filtroPratiche(): FiltroPratica {
    return this._filtroPratiche;
  }

  set filtroPratiche(value: FiltroPratica) {
    this._filtroPratiche = value;
    console.log("Filtro aggiornato:", value);
    // Esegui altre azioni necessarie
  }

  protected showEliminaFileALTROConfirmation: boolean = false;

  @ViewChild("praticheDT", { static: true }) praticheDT: any;

  constructor(
    private logger: NGXLogger,
    public firestore: AngularFirestore,
    public utilService: UtilService,
    protected stiliService: StiliService,
    private userService: UserService,
    public dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private praticheService: PraticheService,
    private excelService: ExcelService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private odaService: OdaService,
    protected listeService: ListeService,
    private aziendeService: ImpreseService,
    private magazzinoService: MagazzinoService,
  ) {
    this._filtroPratiche = {};
    this.setUserRole();
    this.loadImprese();
  }
  loadImprese() {
    this.aziendeService.getByBando("2").subscribe((aziende) => {
      this.imprese = aziende;
    });
  }

  ngOnDestroy(): void {}

  ngOnInit() {
    this.initCSVBox();
    // this.logger.info("ON ONIT FASE 1 BANDO 2");
    const urlParamInLavorazione =
      this.activatedRoute.snapshot.paramMap.get("lavorazione");
    const urlParamLotto = this.activatedRoute.snapshot.paramMap.get("lotto");
    const urlParamCodiceInfratel =
      this.activatedRoute.snapshot.paramMap.get("stato");
    const urlParamOda = this.activatedRoute.snapshot.paramMap.get("oda");
    const urlParamStatoFlowdy =
      this.activatedRoute.snapshot.paramMap.get("stato-flowdy");
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.filtroDaPagare = params.get("da-pagare") === "true";
      this.filtroLottoPerFase = params.get("lotto");
      this.filtroInLavorazione = params.get("in-lavorazione") === "true";
      this.filtroImpresa = params.get("impresa");
      this.filtroStatoSopralluogo = params.get("statoSopralluogo");
      this.filtroPratica = params.get("pratica");
      this.filtroRegione = params.get("regione");
      this.filtroStatoFlowdy = params.get("stato-flowdy");
      this.paginaBack = params.get("from");
      this.filtroTipoSedeEffettivaSop = params.get("tipoSedeEffettivaSop");
      if (this.filtroStatoSopralluogo) {
        switch (this.filtroStatoSopralluogo) {
          case "noSopralluogo":
            this.statoSopralluogo = "SENZA SOPRALLUOGO";
            break;
          case "noSopralluogoPF":
            this.statoSopralluogo = "SENZA SOPRALLUOGO (PF)";
            break;
          case "sopralluogoPianificato":
            this.statoSopralluogo = "CON SOPRALLUOGO PIANIFICATO";
            break;
          case "sopralluogoEseguito":
            this.statoSopralluogo = "CON SOPRALLUOGO ESEGUITO";
            break;
          case "sopralluogoKO":
            this.statoSopralluogo = "CON SOPRALLUOGO KO";
            break;
          default:
            break;
        }
      }
      if (this.filtroImpresa) {
        this.ragioneSocialeImpresa = params.get("ragioneSocialeImpresa");
      }

      if (this.filtroTipoSedeEffettivaSop) {
        const tipo = this.filtroTipoSedeEffettivaSop.toString().trim();
        this.logger.info(
          "[PRATICHE FASE 1] FILTRO PER TIPO Sede EFFETTIVA " + tipo,
        );
        if (tipo.length > 0) {
          if (!this._filtroPratiche.tipo) {
            this._filtroPratiche.tipo = [];
          }
          if (this._filtroPratiche.tipo.indexOf(tipo) === -1) {
            this._filtroPratiche.tipo.push(tipo);
          }
          this.logger.info(
            "[PRATICHE FASE 1] FILTRO PER TIPO Sede EFFETTIVA " +
              tipo +
              " AGGIUNTO AL FILTRO ",
          );
        }
      }
    });
    if (
      this.filtroInLavorazione ||
      this.filtroImpresa ||
      this.filtroPratica ||
      this.filtroStatoSopralluogo ||
      this.filtroStatoFlowdy
    ) {
      this.filterIsSet = true;
    }

    /* this.activatedRoute.queryParamMap.subscribe((params) => {
        
      });

      if(urlParamInLavorazione){
        this.filtroInLavorazione = urlParamInLavorazione;
        this.filterIsSet = true;
      } else */ if (urlParamLotto) {
      this.filtroLotto = urlParamLotto;
      this.filterIsSet = true;
    } else if (urlParamCodiceInfratel) {
      this.filtroStatoInfratel = urlParamCodiceInfratel;
      this.filterIsSet = true;
    } else if (urlParamOda) {
      this.filtroOda = urlParamOda;
      this.filterIsSet = true;
    } /* else if(urlParamStatoFlowdy){
        this.filtroStatoFlowdy = urlParamStatoFlowdy;
        this.filterIsSet = true;
      } */
    /*  // this.logger.info("filtroInLavorazione "+ this.filtroInLavorazione);
      // this.logger.info("filtroLotto "+ this.filtroLotto);
      // this.logger.info("filtroStatoInfratel "+ this.filtroStatoInfratel);
      // this.logger.info("filtroOda "+ this.filtroOda);
      // this.logger.info("filtroDaPagare "+ this.filtroDaPagare);
      // this.logger.info("filtroLottoPerFase "+ this.filtroLottoPerFase); */
    this.loadPratiche();
  }

  initCSVBox() {
    this.csvbox_importer_comunicaEsitiConsegnaBando2 = new CSVBoxImporter(
      this.csvbox_licenseKey_comunicaEsitiConsegnaBando2,
      {},
      (result: boolean, data: any) => {
        if (result) {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail:
              data.row_success + " pratiche bando 1 AGGIORNATE con successo!",
            life: 10000,
          });
        } else {
          this.messageService.add({
            severity: "info",
            summary: "Errore",
            detail:
              "Errore in fase di INSERIMENTO DEGLI ESITI DELLA CONSEGNA DI FASE 1 delle pratiche del bando 1",
            life: 10000,
          });
        }
      },
    );

    this.csvbox_importer_comunicaEsitiConsegnaBando2.setUser({
      user_id: "default123",
    });

    this.csvbox_importer_comunicaEsitiConsegnaBando2.language = "it";
  }

  async openCaricaAzioni(
    event: any,
    pratica: PraticaFlowdy2_Firestore,
  ): Promise<void> {
    this.selectedPratica = pratica;
    this.loadAzioni(event, pratica);
    this.azioniMenuTiered.toggle(event);
  }

  checkCodiceInvioUgualeColocate(pratica: PraticaFlowdy2_Firestore): boolean {
    let sameCodiceInvio = true;

    if (pratica.colocataRuolo === "SECONDARIA") {
      //// this.logger.info("> checkCodiceInvioUgualeColocate su pratica "+ pratica.cui + " / SECONDARIA");

      let principale: PraticaFlowdy2_Firestore =
        this.getPraticaPrincipaleDiUnaColocata(
          pratica.colocataScuolaPrincipale,
        );
      if (principale) {
        //// this.logger.info("> checkCodiceInvioUgualeColocate su pratica "+ pratica.cui + " "+ pratica.colocataRuolo + " -> "+ pratica.codiceInvio + " vs "+ principale.codiceInvio);

        if (principale.codiceInvio && pratica.codiceInvio) {
          if (principale && principale.codiceInvio !== pratica.codiceInvio) {
            sameCodiceInvio = false;
          }
        } else {
          sameCodiceInvio = false;
        }
      }
    } else if (pratica.colocataRuolo === "PRINCIPALE") {
      //// this.logger.info("> checkCodiceInvioUgualeColocate su pratica "+ pratica.cui + " / PRINCIPALE");

      let secondarie: PraticaFlowdy2_Firestore[] =
        this.getPraticheColocateDiUnaPrincipale(pratica.cui);
      secondarie.forEach((secondaria) => {
        //// this.logger.info(secondaria.cui + " "+ secondaria.codiceInvio + " "+ secondaria.statoFlowdyFase1);
        if (secondaria.codiceInvio !== pratica.codiceInvio) {
          sameCodiceInvio = false;
        }
      });
    }
    // this.logger.info("> checkCodiceInvioUgualeColocate su pratica "+ pratica.cui + " RISULTATO "+ sameCodiceInvio);

    return sameCodiceInvio;
  }

  getPraticaPrincipaleDiUnaColocata(
    cuiPrincipale: string,
  ): PraticaFlowdy2_Firestore {
    return this.pratiche.find((pratica) => pratica.cui === cuiPrincipale);
  }

  getPraticheColocateDiUnaPrincipale(
    cuiPrincipale: string,
  ): PraticaFlowdy2_Firestore[] {
    return this.praticheSenzaEscludereLeKO.filter(
      (pratica) => pratica.colocataScuolaPrincipale === cuiPrincipale,
    );
  }

  visualizzaNote(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;

    this.praticheService.getNote(pratica.id).subscribe((notePratica) => {
      this.isLoadingResults = false;
      this.ref = this.dialogService.open(StoricoNotePraticaComponent, {
        data: {
          pratica: pratica,
          note: notePratica,
        },
        header: "NOTE della pratica " + pratica.cui,
        width: "50%",
        height: "85%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    });
  }

  loadAzioni(event: any, pratica: PraticaFlowdy2_Firestore) {
    this.menuAzioniItems = [];
    this.menuAzioniItems.push(
      {
        label: "Storico",
        icon: PrimeIcons.HISTORY,
        style: { "font-size": "12px" },
        command: () => this.openStoricoPratica(pratica),
      },
      /* {
          label: "Posizione",
          icon: PrimeIcons.MAP_MARKER,
          style: {'font-size': '12px'},
          command: () => this.openMappaConScuola(pratica),
        }   */
    );
    //AZIONI PER TUTTI:
    //LOCALIZZA
    //STORICO
    //AZIONI IMPRESA
    if (this.isImpresa) {
      //inizio
      if (
        !pratica.colocata ||
        (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
        (pratica.colocata &&
          pratica.colocataRuolo === "SECONDARIA" &&
          !this.checkCodiceInvioUgualeColocate(pratica))
      ) {
        if (pratica.statoFlowdyFase1 === "DA ASSEGNARE") {
          this.menuAzioniItems.push({
            label: "Prendi in carico",
            icon: "icona-sf_in_carico",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.openPrendiInCarico(pratica),
          });
        }
      }
      if (pratica.statoFlowdyFase1 === "ASSEGNATA") {
        this.menuAzioniItems.push({
          label: "Data sopralluogo",
          icon: "icona-data-sopralluogo",
          style: { "font-weight": "bold", "font-size": "12px" },
          command: () => this.comunicaDataSopralluogo(pratica),
        });
      }
      if (pratica.statoFlowdyFase1 === "SOPRALLUOGO PIANIFICATO") {
        this.menuAzioniItems.push({
          label: "Esito sopralluogo",
          icon: "icona-comunica-esito",
          style: { "font-weight": "bold", "font-size": "12px" },
          command: () => this.comunicaEsitoSopralluogo(pratica),
        });
      }

      if (
        pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" ||
        pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO" ||
        pratica.statoFlowdyFase1 === "PREVENTIVO RIFIUTATO"
      ) {
        //gestione dei preventivi
        let itemsPreventivo: any[] = [];

        if (pratica.statoFlowdyFase1 !== "PREVENTIVO APPROVATO") {
          itemsPreventivo.push({
            label: "Modifica",
            icon: "pi pi-file-edit",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.modificaPreventivo(pratica),
          });
        }

        if (pratica.filePreventivoUploaded) {
          itemsPreventivo.push({
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "12px" },
            command: () => this.scaricaPreventivo(pratica),
          });
          if (pratica.statoFlowdyFase1 !== "PREVENTIVO APPROVATO") {
            itemsPreventivo.push({
              label: "Carica nuovo",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () => this.caricaPreventivo(pratica),
            });
          }
        } else {
          itemsPreventivo.push({
            label: "Carica nuovo",
            icon: "pi pi-upload",
            style: { "font-size": "12px" },
            command: () => this.caricaPreventivo(pratica),
          });
        }

        this.menuAzioniItems.push({
          label: "Preventivo",
          icon: "icona-preventivo",
          style: { "font-weight": "bold", "font-size": "12px" },
          items: itemsPreventivo,
        });
      }

      if (
        pratica.statoFlowdyFase1 !== "APPROVATA" &&
        pratica.statoFlowdyFase1 !== "PUBBLICATA" &&
        pratica.statoFlowdyFase1 !== "CONSEGNATA" &&
        pratica.statoFlowdyFase1 !== "IN CARICO PRESIDIO" &&
        pratica.statoFlowdyFase1 !== "IN VERIFICA SMARTFIBER" &&
        (pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" ||
          (!pratica.opereExtra && pratica.sopralluogoOk) ||
          (pratica.opereExtra &&
            (pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" ||
              pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO")) ||
          pratica.statoFlowdyFase1 === "RESPINTA")
      ) {
        if (pratica.noteSopralluogo && pratica.noteSopralluogo.length > 0) {
          this.menuAzioniItems.push({
            label: "Mostra note",
            icon: "icona-note-impresa",
            style: { "font-size": "12px" },
            command: () => this.apriNoteImpresa(pratica),
          });
        }

        //gestione dei documenti
        let itemsRT: any[] = [];
        let itemsVerbale: any[] = [];
        let itemsDUVRI: any[] = [];
        let itemsAltri: any[] = [];
        itemsRT.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "12px" },
          command: () => this.caricaDocumento(pratica, "RET"),
        });

        itemsVerbale.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "12px" },
          command: () =>
            this.caricaDocumento(pratica, "VERBALE DEL SOPRALLUOGO"),
        });
        itemsDUVRI.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "12px" },
          command: () => this.caricaDocumento(pratica, "DUVRI"),
        });
        itemsAltri.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "12px" },
          command: () => this.caricaDocumento(pratica, "ALTRI"),
        });

        if (pratica.fileRETUploaded) {
          itemsRT.push({
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "12px" },
            command: () => this.scaricaDoc(pratica, "RET"),
          });
        }
        if (pratica.fileVerbaleSopralluogoUploaded) {
          itemsVerbale.push({
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "12px" },
            command: () => this.scaricaDoc(pratica, "VERBALE"),
          });
        }
        if (pratica.fileDUVRIUploaded) {
          itemsDUVRI.push({
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "12px" },
            command: () => this.scaricaDoc(pratica, "DUVRI"),
          });
        }
        if (pratica.fileAltriUploaded) {
          itemsAltri.push(
            {
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "12px" },
              command: () => this.scaricaDoc(pratica, "ALTRI"),
            },
            {
              label: "Elimina tutti",
              icon: PrimeIcons.ERASER,
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () =>
                this.chiediEliminazioneTuttiFileCaricati(pratica, "ALTRO"),
            },
          );
        }

        let itemsDocumenti: any[] = [
          {
            label: "RET",
            style: { "font-size": "12px" },
            items: itemsRT,
          },
          {
            label: "Verbale Sopralluogo",
            style: { "font-size": "12px" },
            items: itemsVerbale,
          },
          {
            label: "DUVRI",
            style: { "font-size": "12px" },
            items: itemsDUVRI,
          },
          {
            label: "Altri",
            style: { "font-size": "12px" },
            items: itemsAltri,
          },
        ];

        if (
          pratica.fileRETUploaded ||
          pratica.fileVerbaleSopralluogoUploaded ||
          pratica.fileDUVRIUploaded ||
          pratica.fileAltriUploaded
        ) {
          itemsDocumenti.push({
            label: "Scarica tutto",
            icon: "pi pi-download",
            style: { "font-size": "12px" },
            command: () => this.scaricaTuttaDocumentazione(pratica),
          });
        }
        this.menuAzioniItems.push({
          label: "Documentazione",
          icon: "icona-documentazione",
          style: { "font-weight": "bold", "font-size": "12px" },
          items: itemsDocumenti,
        });
      }

      if (
        !pratica.colocata ||
        (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
        (pratica.colocata &&
          pratica.colocataRuolo === "SECONDARIA" &&
          !this.checkCodiceInvioUgualeColocate(pratica))
      ) {
        if (this.checkIfDeliverable(pratica)) {
          this.menuAzioniItems.push({
            label: "Consegna",
            icon: "pi pi-send",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.consegnaPratica(pratica),
          });
        }
      }

      if (pratica.statoFlowdyFase1 === "IN REWORK AZIENDA") {
        let itemsPreventivo: any[] = [
          {
            label: "Modifica",
            icon: "pi pi-file-edit",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.modificaPreventivo(pratica),
          },
        ];
        if (pratica.filePreventivoUploaded) {
          itemsPreventivo.push(
            {
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "12px" },
              command: () => this.scaricaPreventivo(pratica),
            },
            {
              label: "Carica nuovo",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () => this.caricaPreventivo(pratica),
            },
          );
        } else {
          itemsPreventivo.push({
            label: "Carica nuovo",
            icon: "pi pi-upload",
            style: { "font-size": "12px" },
            command: () => this.caricaPreventivo(pratica),
          });
        }

        this.menuAzioniItems.push(
          {
            label: "Preventivo",
            icon: "icona-preventivo",
            style: { "font-weight": "bold", "font-size": "12px" },
            items: itemsPreventivo,
          },
          {
            label: "Note rework",
            icon: "icona-note_rework",
            style: { "font-size": "12px" },
            command: () => this.apriNoteRework(pratica),
          },
        );
        if (
          !pratica.colocata ||
          (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
          (pratica.colocata &&
            pratica.colocataRuolo === "SECONDARIA" &&
            !this.checkCodiceInvioUgualeColocate(pratica))
        ) {
          this.menuAzioniItems.push({
            label: "Riconsegna",
            icon: "pi pi-send",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.consegnaPratica(pratica),
          });
        }
      }
      if (pratica.statoFlowdyFase1 === "CONSEGNATA") {
        if (
          !pratica.colocata ||
          (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
          (pratica.colocata &&
            pratica.colocataRuolo === "SECONDARIA" &&
            !this.checkCodiceInvioUgualeColocate(pratica))
        ) {
          this.menuAzioniItems.push({
            label: "Annulla consegna",
            icon: "pi pi-undo",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.annullaConsegna(pratica),
          });
        }
      }

      if (pratica.statoFlowdyFase1 === "RESPINTA") {
        if (
          !pratica.colocata ||
          (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
          (pratica.colocata &&
            pratica.colocataRuolo === "SECONDARIA" &&
            !this.checkCodiceInvioUgualeColocate(pratica))
        ) {
          this.menuAzioniItems.push(
            {
              label: "Note respingimento",
              icon: "icona-note_rework",
              style: { "font-size": "12px" },
              command: () => this.apriNoteRespingimento(pratica),
            },
            {
              label: "Riconsegna",
              icon: "pi pi-send",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.consegnaPratica(pratica),
            },
          );
        }
      }
      if (
        pratica.statoFlowdyFase1 === "CONSEGNATA" ||
        pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER" ||
        pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO" ||
        pratica.statoFlowdyFase1 === "PUBBLICATA" ||
        pratica.statoFlowdyFase1 === "APPROVATA"
      ) {
        if (
          !pratica.colocata ||
          (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
          (pratica.colocata &&
            pratica.colocataRuolo === "SECONDARIA" &&
            !this.checkCodiceInvioUgualeColocate(pratica))
        ) {
          this.menuAzioniItems.push({
            label: "Scarica pacchetto",
            icon: "icona-scarica_pacchetto",
            style: { "font-size": "12px" },
            command: () => this.scaricaPacchettoPratica(pratica),
          });
        }
      }

      //fine
    } else if (
      this.isPresidioSF ||
      this.isAdmin ||
      this.isSuperAdmin ||
      this.isDemo
    ) {
      //AZIONI SF & ADMIN

      this.menuAzioniItems.push({
        label: "Note",
        icon: "icona-note-presidio",
        style: { "font-size": "12px" },
        // items:itemsNote,
        command: () => this.visualizzaNote(pratica),
      });
      //GESTIONE DELLE COLOCATE
      if (
        !pratica.colocata ||
        //  pratica.colocataRuolo ==='PRINCIPALE'
        (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
        (pratica.colocata &&
          pratica.colocataRuolo === "SECONDARIA" &&
          !this.checkCodiceInvioUgualeColocate(pratica))
      ) {
        //SULLE SINGOLE E SULLE PRINCIPALI DELLE COLOCATE
        if (pratica.statoFlowdyFase1 === "IN ATTESA ODA") {
          this.menuAzioniItems.push({
            label: "Elimina",
            icon: PrimeIcons.ERASER,
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.eliminaPratica(pratica),
          });
          this.menuAzioniItems.push({
            label: "Assegna ODA",
            icon: "icona-assegna-oda",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.assegnaODA(pratica),
            disabled: this.isDemo,
          });
        }
        if (pratica.statoFlowdyFase1 === "DA ASSEGNARE") {
          this.menuAzioniItems.push({
            label: "Elimina",
            icon: PrimeIcons.ERASER,
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.eliminaPratica(pratica),
          });
          this.menuAzioniItems.push({
            label: "Prendi in carico",
            icon: "icona-sf_in_carico",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.openPrendiInCarico(pratica),
            disabled: this.isDemo,
          });
        }
      } else {
        //SULLE SECONDARIE DELLE COLOCATE
        //// this.logger.info("*** SECONDARIE");
      }
      if (pratica.statoFlowdyFase1 === "ASSEGNATA") {
        this.menuAzioniItems.push({
          label: "Data sopralluogo",
          icon: "icona-data-sopralluogo",
          style: { "font-weight": "bold", "font-size": "12px" },
          command: () => this.comunicaDataSopralluogo(pratica),
          disabled: this.isDemo,
        });
      }
      if (pratica.statoFlowdyFase1 === "SOPRALLUOGO PIANIFICATO") {
        this.menuAzioniItems.push({
          label: "Esito sopralluogo",
          icon: "icona-comunica-esito",
          style: { "font-weight": "bold", "font-size": "12px" },
          command: () => this.comunicaEsitoSopralluogo(pratica),
          disabled: this.isDemo,
        });
      }

      if (
        (pratica.statoFlowdyFase1 === "CONSEGNATA" &&
          pratica.statoPreventivo === "IN ATTESA") ||
        pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" ||
        pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO" ||
        pratica.statoFlowdyFase1 === "PREVENTIVO RIFIUTATO"
      ) {
        //gestione dei preventivi
        let itemsPreventivo: any[] = [
          {
            label: "Modifica",
            icon: "pi pi-file-edit",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.modificaPreventivo(pratica),
            disabled: this.isDemo,
          },
        ];
        if (pratica.filePreventivoUploaded) {
          itemsPreventivo.push(
            {
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "12px" },
              command: () => this.scaricaPreventivo(pratica),
            },
            {
              label: "Carica nuovo",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () => this.caricaPreventivo(pratica),
              disabled: this.isDemo,
            },
          );
        } else {
          itemsPreventivo.push({
            label: "Carica nuovo",
            icon: "pi pi-upload",
            style: { "font-size": "12px" },
            command: () => this.caricaPreventivo(pratica),
            disabled: this.isDemo,
          });
        }
        if (
          (pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" ||
            pratica.statoFlowdyFase1 === "PREVENTIVO RIFIUTATO") &&
          pratica.filePreventivoUploaded
        ) {
          itemsPreventivo.push(
            {
              label: "Approva",
              icon: "pi pi-thumbs-up-fill",
              style: { "font-size": "12px" },
              command: () => this.approvaPreventivo(pratica),
              disabled: this.isDemo,
            },
            {
              label: "Rifiuta",
              icon: "pi pi-thumbs-down-fill",
              style: { "font-size": "12px" },
              command: () => this.rifiutaPreventivo(pratica),
              disabled: this.isDemo,
            },
          );
        }
        this.menuAzioniItems.push({
          label: "Preventivo",
          icon: "icona-preventivo",
          style: { "font-weight": "bold", "font-size": "12px" },
          items: itemsPreventivo,
        });
      }
      if (
        pratica.statoFlowdyFase1 === "SOPRALLUOGO EFFETTUATO" ||
        pratica.statoFlowdyFase1 === "RESPINTA" ||
        pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" ||
        pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" ||
        pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO" ||
        pratica.statoFlowdyFase1 === "CONSEGNATA" ||
        pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER"
      ) /* if(
            pratica.statoFlowdyFase1 !== "APPROVATA" && pratica.statoFlowdyFase1 !== "PUBBLICATA" && 
            pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" 
            || pratica.statoFlowdyFase1 === "RESPINTA"  
            || (!pratica.opereExtra && pratica.sopralluogoOk) || (pratica.opereExtra && (pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" || pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO"))) 
        */ {
        //gestione dei documenti
        if (pratica.noteSopralluogo && pratica.noteSopralluogo.length > 0) {
          this.menuAzioniItems.push({
            label: "Mostra note",
            icon: "icona-note-impresa",
            style: { "font-size": "12px" },
            command: () => this.apriNoteImpresa(pratica),
          });
        }

        let itemsRT: any[] = [];
        let itemsVerbale: any[] = [];
        let itemsDUVRI: any[] = [];
        let itemsAltri: any[] = [];
        itemsRT.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "12px" },
          command: () => this.caricaDocumento(pratica, "RET"),
          disabled: this.isDemo,
        });

        itemsVerbale.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "12px" },
          command: () =>
            this.caricaDocumento(pratica, "VERBALE DEL SOPRALLUOGO"),
          disabled: this.isDemo,
        });
        itemsDUVRI.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "12px" },
          command: () => this.caricaDocumento(pratica, "DUVRI"),
          disabled: this.isDemo,
        });
        itemsAltri.push({
          label: "Carica",
          icon: "pi pi-upload",
          style: { "font-size": "12px" },
          command: () => this.caricaDocumento(pratica, "ALTRI"),
          disabled: this.isDemo,
        });

        if (pratica.fileRETUploaded) {
          itemsRT.push({
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "12px" },
            command: () => this.scaricaDoc(pratica, "RET"),
          });
        }
        if (pratica.fileVerbaleSopralluogoUploaded) {
          itemsVerbale.push({
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "12px" },
            command: () => this.scaricaDoc(pratica, "VERBALE"),
          });
        }
        if (pratica.fileDUVRIUploaded) {
          itemsDUVRI.push({
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "12px" },
            command: () => this.scaricaDoc(pratica, "DUVRI"),
          });
        }
        if (pratica.fileAltriUploaded) {
          itemsAltri.push(
            {
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "12px" },
              command: () => this.scaricaDoc(pratica, "ALTRI"),
            },
            {
              label: "Elimina tutti",
              icon: PrimeIcons.ERASER,
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () =>
                this.chiediEliminazioneTuttiFileCaricati(pratica, "ALTRO"),
            },
          );
        }

        let itemsDocumenti: any[] = [
          {
            label: "RET",
            style: { "font-size": "12px" },
            items: itemsRT,
          },
          {
            label: "Verbale Sopralluogo",
            style: { "font-size": "12px" },
            items: itemsVerbale,
          },
          {
            label: "DUVRI",
            style: { "font-size": "12px" },
            items: itemsDUVRI,
          },
          {
            label: "Altri",
            style: { "font-size": "12px" },
            items: itemsAltri,
          },
        ];
        if (
          pratica.noteBocciaturaPresidio &&
          pratica.noteBocciaturaPresidio.length > 0
        ) {
          this.menuAzioniItems.push({
            label: "Mostra note presidio",
            icon: "icona-documentazione",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.apriNoteBocciaturaPresidio(pratica),
          });
        }
        // this.logger.info(pratica.cui + " FILE CARICATI? " + pratica.fileRETUploaded + " "+ pratica.fileVerbaleSopralluogoUploaded+ " "+ pratica.fileDUVRIUploaded+ " " + pratica.fileAltriUploaded);
        if (
          pratica.fileRETUploaded ||
          pratica.fileVerbaleSopralluogoUploaded ||
          pratica.fileDUVRIUploaded ||
          pratica.fileAltriUploaded
        ) {
          itemsDocumenti.push({
            label: "Scarica tutto",
            icon: "pi pi-download",
            style: { "font-size": "12px" },
            command: () => this.scaricaTuttaDocumentazione(pratica),
          });
        } else {
          // this.logger.info("entra nell'else....");
        }
        this.menuAzioniItems.push({
          label: "Documentazione",
          icon: "icona-documentazione",
          style: { "font-weight": "bold", "font-size": "12px" },
          items: itemsDocumenti,
        });
      }

      //se tutta la documentazione caricata -> consegna
      if (
        (!pratica.opereExtra && pratica.sopralluogoOk) ||
        (pratica.opereExtra &&
          (pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" ||
            pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO"))
      ) {
        //
      }

      if (
        !pratica.colocata ||
        (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
        (pratica.colocata &&
          pratica.colocataRuolo === "SECONDARIA" &&
          !this.checkCodiceInvioUgualeColocate(pratica))
      ) {
        if (this.checkIfDeliverable(pratica)) {
          this.menuAzioniItems.push({
            label: "Consegna",
            icon: "pi pi-send",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.consegnaPratica(pratica),
            disabled: this.isDemo,
          });
        }
      }

      if (pratica.statoFlowdyFase1 === "IN REWORK AZIENDA") {
        let itemsPreventivo: any[] = [
          {
            label: "Modifica",
            icon: "pi pi-file-edit",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.modificaPreventivo(pratica),
            disabled: this.isDemo,
          },
        ];
        if (pratica.filePreventivoUploaded) {
          itemsPreventivo.push(
            {
              label: "Scarica",
              icon: "pi pi-download",
              style: { "font-size": "12px" },
              command: () => this.scaricaPreventivo(pratica),
            },
            {
              label: "Carica nuovo",
              icon: "pi pi-upload",
              style: { "font-size": "12px" },
              command: () => this.caricaPreventivo(pratica),
              disabled: this.isDemo,
            },
          );
        } else {
          itemsPreventivo.push({
            label: "Carica nuovo",
            icon: "pi pi-upload",
            style: { "font-size": "12px" },
            command: () => this.caricaPreventivo(pratica),
            disabled: this.isDemo,
          });
        }
        this.menuAzioniItems.push(
          {
            label: "Preventivo",
            icon: "icona-preventivo",
            style: { "font-weight": "bold", "font-size": "12px" },
            items: itemsPreventivo,
          },
          {
            label: "Note rework",
            icon: "icona-note_rework",
            style: { "font-size": "12px" },
            command: () => this.apriNoteRework(pratica),
          },

          {
            label: "Riconsegna",
            icon: "pi pi-send",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.consegnaPratica(pratica),
            disabled: this.isDemo,
          },
        );
      }

      if (pratica.statoFlowdyFase1 === "CONSEGNATA") {
        if (
          !pratica.colocata ||
          //  pratica.colocataRuolo ==='PRINCIPALE'
          (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
          (pratica.colocata &&
            pratica.colocataRuolo === "SECONDARIA" &&
            !this.checkCodiceInvioUgualeColocate(pratica))
        ) {
          this.menuAzioniItems.push(
            {
              label: "Annulla consegna",
              icon: "pi pi-undo",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.annullaConsegna(pratica),
              disabled: this.isDemo,
            },
            {
              label: "Prendi in carico",
              icon: "icona-sf_in_carico",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.openPrendiInCarico(pratica),
              disabled: this.isDemo,
            },
          );
        }
      }
      if (
        pratica.statoFlowdyFase1 !== "IN REWORK AZIENDA" &&
        (pratica.noteRET || pratica.noteDUVRI || pratica.noteVerbale)
      ) {
        this.menuAzioniItems.push({
          label: "Note rework",
          icon: "icona-note_rework",
          style: { "font-size": "12px" },
          command: () => this.apriNoteRework(pratica),
        });
      }
      if (pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER") {
        if (
          !pratica.colocata ||
          (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
          (pratica.colocata &&
            pratica.colocataRuolo === "SECONDARIA" &&
            !this.checkCodiceInvioUgualeColocate(pratica))
        ) {
          this.menuAzioniItems.push(
            /* {
                      label: "Scarica tutto",
                       icon: 'pi pi-download',
                      style: {  'font-size': '12px'},
                      command: () => this.scaricaTuttaDocumentazione(pratica),
                    }, */
            {
              label: "Valida consegna",
              icon: "icona-validazione-consegna",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.validaConsegna(pratica),
              disabled: this.isDemo,
            },
          );
        }
      }

      if (pratica.statoFlowdyFase1 === "SOPRALLUOGO KO") {
        this.menuAzioniItems.push({
          label: "Nuovo Sopralluogo",
          icon: "icona-comunica-esito",
          style: { "font-weight": "bold", "font-size": "12px" },
          command: () => this.comunicaEsitoSopralluogo(pratica),
          disabled: this.isDemo,
        });
      }

      if (pratica.statoFlowdyFase1 === "RESPINTA") {
        if (
          !pratica.colocata ||
          (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
          (pratica.colocata &&
            pratica.colocataRuolo === "SECONDARIA" &&
            !this.checkCodiceInvioUgualeColocate(pratica))
        ) {
          this.menuAzioniItems.push(
            {
              label: "Note respingimento",
              icon: "icona-note_rework",
              style: { "font-size": "12px" },
              command: () => this.apriNoteRespingimento(pratica),
            },
            {
              label: "Riconsegna",
              icon: "pi pi-send",
              style: { "font-weight": "bold", "font-size": "12px" },
              command: () => this.consegnaPratica(pratica),
              disabled: this.isDemo,
            },
          );
        }
      }

      if (
        pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO" ||
        pratica.statoFlowdyFase1 === "PUBBLICATA" ||
        pratica.statoFlowdyFase1 === "APPROVATA"
      ) {
        if (
          !pratica.colocata ||
          (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
          (pratica.colocata &&
            pratica.colocataRuolo === "SECONDARIA" &&
            !this.checkCodiceInvioUgualeColocate(pratica))
        ) {
          this.menuAzioniItems.push({
            label: "Scarica pacchetto",
            icon: "icona-scarica_pacchetto",
            style: { "font-size": "12px" },
            command: () => this.scaricaPacchettoPratica(pratica),
          });
        }
      }
      // if(){
      if (
        !pratica.colocata ||
        (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
        (pratica.colocata &&
          pratica.colocataRuolo === "SECONDARIA" &&
          !this.checkCodiceInvioUgualeColocate(pratica))
      ) {
        this.menuAzioniItems.push(
          {
            label: "Cambia Stato",
            icon: "icona-forza_stato",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.forzaStatoPratica(pratica),
            disabled: this.isDemo,
          },
          {
            label: "Resetta",
            icon: "icona-reset",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.resettaPratica(pratica),
            disabled: this.isDemo,
          },
        );
      }

      // }
    } else if (this.isPresidioTIM) {
      //AZIONI PRESIDIO TIM
      //SCARICA PACCHETTI DI PRATICHE CON TUTTO OK

      if (
        !pratica.colocata ||
        (pratica.colocata && pratica.colocataRuolo === "PRINCIPALE") ||
        (pratica.colocata &&
          pratica.colocataRuolo === "SECONDARIA" &&
          !this.checkCodiceInvioUgualeColocate(pratica))
      ) {
        this.menuAzioniItems.push(
          {
            label: "Scarica pacchetto",
            icon: "icona-scarica_pacchetto",
            style: { "font-size": "12px" },
            command: () => this.scaricaPacchettoPratica(pratica),
          },
          {
            label: "Rifiuta consegna",
            icon: "icona-rifiuta_consegna",
            style: { "font-weight": "bold", "font-size": "11px" },
            command: () => this.rifiutaConsegna(pratica),
          },
        );
        if (pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO") {
          this.menuAzioniItems.push({
            label: "Invio Infratel",
            icon: "icona-invio-infratel",
            style: { "font-weight": "bold", "font-size": "11px" },
            command: () => this.comunicaInvioInfratelPratica(pratica),
          });
        }
        if (pratica.statoFlowdyFase1 === "PUBBLICATA") {
          this.menuAzioniItems.push({
            label: "Esito",
            icon: "icona-comunica_esito",
            style: { "font-weight": "bold", "font-size": "12px" },
            items: [
              {
                label: "Approvata",
                icon: "icona-fase1_approvata",
                style: { "font-size": "12px" },
                command: () => this.comunicaEsitoFase1(pratica, true),
              },
              {
                label: "Respinta",
                icon: "icona-fase1_respinta",
                style: { "font-size": "12px" },
                command: () => this.comunicaEsitoFase1(pratica, false),
              },
            ],
          });
        }
      }

      //MODIFICA LO STATO IN APPROVATE
    } else if (this.isPM) {
      //AZIONI PM
      this.menuAzioniItems.push({
        label: "Note",
        icon: "icona-note-presidio",
        style: { "font-size": "12px" },
        command: () => this.visualizzaNote(pratica),
      });
      if (
        (pratica.statoFlowdyFase1 === "CONSEGNATA" ||
          pratica.statoFlowdyFase1 === "IN VERIFICA SMARTFIBER" ||
          pratica.statoFlowdyFase1 === "IN CARICO PRESIDIO" ||
          pratica.statoFlowdyFase1 === "PUBBLICATA" ||
          pratica.statoFlowdyFase1 === "APPROVATA" ||
          pratica.statoFlowdyFase1 === "RESPINTA" ||
          pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" ||
          pratica.statoFlowdyFase1 === "PREVENTIVO RIFIUTATO") &&
        pratica.filePreventivoUploaded
      ) {
        let itemsPreventivo: any[] = [];
        itemsPreventivo.push(
          {
            label: "Scarica",
            icon: "pi pi-download",
            style: { "font-size": "12px" },
            command: () => this.scaricaPreventivo(pratica),
          },
          {
            label: "Approva",
            icon: "pi pi-thumbs-up-fill",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.approvaPreventivo(pratica),
          },
          {
            label: "Rifiuta",
            icon: "pi pi-thumbs-down-fill",
            style: { "font-weight": "bold", "font-size": "12px" },
            command: () => this.rifiutaPreventivo(pratica),
          },
        );

        this.menuAzioniItems.push({
          label: "Preventivo",
          icon: "icona-preventivo",
          style: { "font-weight": "bold", "font-size": "12px" },
          items: itemsPreventivo,
        });
      }
    } else if (this.isDirigenteFirmaPacchetti) {
      this.menuAzioniItems.push({
        label: "Note",
        icon: "icona-note-presidio",
        style: { "font-size": "12px" },
        command: () => this.visualizzaNote(pratica),
      });
    }

    /* this.menuAzioniItems.push(
        {
          label: "BEF",
          style: {  'font-size': '13px'},
          icon: PrimeIcons.SHOPPING_CART,
          command: () => this.apriBEF(oda),
        },
        {
          label: "Pratiche",
          style: {  'font-size': '13px'},
          icon: "pi pi-clipboard",
          items:[
            {
              label: "Fase I",
              style: {  'font-size': '13px'},
              icon: 'icona-fase-1',
              command: () => this.mostraPratiche(oda, 'FASE 1'),
            },
            {
              label: "Fase II",
              style: {  'font-size': '13px'},
              icon: 'icona-fase-2',
              command: () => this.mostraPratiche(oda, 'FASE 2'),
            },
            {
              label: "Fase III",
              style: {  'font-size': '13px'},
              icon: 'icona-fase-3',
              command: () => this.mostraPratiche(oda, 'FASE 3'),
            }
          ]
       
        },
      ); */
  }

  importaEsitiConsegna() {
    this.importID = uuidv4();
    this.csvbox_importer_comunicaEsitiConsegnaBando2.setUser({
      importID: this.importID,
    });
    this.csvbox_importer_comunicaEsitiConsegnaBando2.openModal();
    //this.csvbox_importer_comunicaEsitiConsegnaBando2.openModal();
  }

  aggiungiNota(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;

    this.ref = this.dialogService.open(CreaNotaPraticaComponent, {
      data: {
        pratica: pratica,
      },
      header: "Crea NOTA per la pratica " + pratica.cui,
      width: "50%",
      height: "55%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((creaNota) => {
      if (creaNota && creaNota.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Nota creata con successo!",
          life: 3000,
        });
      }
    });
    this.isLoadingResults = false;
  }

  eliminaPratica(pratica: PraticaFlowdy2_Firestore) {
    this.showDeletePraticaConfirmation = true;
    this.selectedPratica = pratica;
  }
  confermaEliminazionePratica() {
    this.isLoadingResults = true;
    this.praticheService.eliminaPratica(this.selectedPratica.id).subscribe({
      next: (v) => {
        // this.logger.info("NEXT");
        this.isLoadingResults = false;
        this.showDeletePraticaConfirmation = false;
        this.selectedPratica = null;
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Pratica eliminata!",
          life: 5000,
        });
      },
      error: (e) => {
        this.messageService.add({
          life: 10000,
          severity: "error",
          summary: "Errore",
          detail: "Errore in fase di ELIMINAZIONE della pratica",
        });
        this.isLoadingResults = false;
        this.showDeletePraticaConfirmation = false;
        this.selectedPratica = null;
      },
      complete: () => {
        // this.logger.info("COMPLETE");
      },
    });
  }

  openStoricoPratica(pratica: PraticaFlowdy2_Firestore) {
    this.isLoadingResults = true;
    this.praticheService.getStorico(pratica.id).subscribe((storicoPratica) => {
      this.isLoadingResults = false;
      if (storicoPratica && storicoPratica.length > 0) {
        // this.logger.info(storicoPratica);
        this.ref = this.dialogService.open(StoricoPraticaComponent, {
          data: {
            pratica: pratica,
            storicoPratica: storicoPratica,
            fase: 1,
          },
          header: "Storico della FASE 1 della pratica " + pratica.cui,
          width: "50%",
          height: "85%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
      } else {
        this.messageService.add({
          severity: "info",
          summary: "Attenzione!",
          detail: "La pratica non presenta STORICO",
        });
      }
    });
  }

  rifiutaPreventivo(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogRifiutaPreventivoFase1, {
      data: {
        pratica: pratica,
      },
      header: "Rifiuta preventivo per la pratica " + pratica.cui.toUpperCase(),
      width: "60%",
      height: "70%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((modificaPreventivo) => {
      if (modificaPreventivo && modificaPreventivo.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Preventivo rifiutato!",
          life: 3000,
        });
      }
    });
  }

  comunicaEsitoFase1(pratica: PraticaFlowdy2_Firestore, isApprovata: boolean) {
    if (isApprovata) {
      this.ref = this.dialogService.open(DialogAccettazioneInvioInfratel, {
        data: {
          pratica: pratica,
          fase: 1,
        },
        header:
          "Accettazione della FASE 1 della pratica " +
          pratica.cui.toUpperCase(),
        width: "60%",
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((bocciaturaFase1) => {
        if (bocciaturaFase1 && bocciaturaFase1.success) {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Accettazione della pratica comuinicata!",
            life: 3000,
          });
        }
      });
    } else {
      this.ref = this.dialogService.open(ComunicaBocciatura, {
        data: {
          pratica: pratica,
          fase: 1,
        },
        header:
          "Indica le moditivazioni della bocciatura della FASE 1 della pratica " +
          pratica.cui.toUpperCase(),
        width: "60%",
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((bocciaturaFase1) => {
        if (bocciaturaFase1 && bocciaturaFase1.success) {
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Bocciatura pratica comuinicata!",
            life: 3000,
          });
        }
      });
    }
  }

  confermaApprovazioneFase1() {
    this.showFase1Approvata = false;
    this.selectedPratica = null;
  }

  forzaStatoPratica(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogModificaStato, {
      data: {
        pratica: pratica,
        fase: 1,
      },
      header: "Cambio stato della Pratica " + pratica.cui,
      width: "50%",
      height: "40%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((statoUpdated) => {
      if (statoUpdated && statoUpdated.success) {
        this.isLoadingResults = false;

        this.messageService.add({
          severity: "success",
          summary: "",
          life: 10000,
          detail:
            "Stato della pratica " + pratica.cui + " aggiornato con successo",
        });
      }
    });
  }

  async scaricaPacchettoPratica(pratica: PraticaFlowdy2_Firestore) {
    const storage = getStorage();
    const zipPratica = new JSZip();
    this.isLoadingResults = true;
    if (
      !pratica.colocata ||
      (pratica.colocata && !this.checkCodiceInvioUgualeColocate(pratica))
    ) {
      // this.logger.info("-> scaricaPacchettoPratica ERRORE ");

      const pathReferenceRET = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/IN/FASE_1/documentazione/" +
          pratica.cui +
          "_RET.docx",
      );
      const pathReferenceDUVRI = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/IN/FASE_1/documentazione/" +
          pratica.cui +
          "_DUVRI.pdf",
      );
      const pathReferenceVerbale = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/IN/FASE_1/documentazione/" +
          pratica.cui +
          "_VERBALE.pdf",
      );
      let filesToDownload = [
        pathReferenceRET,
        pathReferenceDUVRI,
        pathReferenceVerbale,
      ];
      const downloadPromises = [];
      for (const pathRef of filesToDownload) {
        try {
          const blob = await getBlob(pathRef);
          if (blob) {
            zipPratica.file(pathRef.name, blob);
            downloadPromises.push(Promise.resolve());
          } else {
            this.logger.error(`Errore durante il download di ${pathRef.name}`);
            downloadPromises.push(Promise.reject());
          }
        } catch (error) {
          this.isLoadingResults = false;
          // this.logger.info(pathRef.name);
        }
      }

      // Scarica altri file se presenti
      if (
        pratica.listaAltriFileUploaded &&
        pratica.listaAltriFileUploaded.length > 0
      ) {
        for (let file of pratica.listaAltriFileUploaded) {
          try {
            const pathReferenceDoc = ref(
              storage,
              "pratiche/scuola/" +
                pratica.cui +
                "/IN/FASE_1/documentazione/" +
                file,
            );

            const blobDoc = await getBlob(pathReferenceDoc);
            if (blobDoc) {
              zipPratica.file(`altri/${file}`, blobDoc);
              downloadPromises.push(Promise.resolve());
            } else {
              this.logger.error(`Errore durante il download di ${file}`);
              downloadPromises.push(Promise.reject());
            }
          } catch (error) {
            this.logger.error(`Errore durante il download di ${file}:`, error);
            downloadPromises.push(Promise.reject());
          }
        }
      }

      Promise.all(downloadPromises).then(() => {
        zipPratica
          .generateAsync({ type: "blob" })
          .then((blob) => {
            saveAs(blob, pratica.cui + ".zip");
            this.isLoadingResults = false;
          })
          .catch((error) =>
            console.error("Errore durante la creazione dello zip:", error),
          );
      });
    } else {
      const pathReferenceRETPrincipale = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/IN/FASE_1/documentazione/" +
          pratica.cui +
          "_RET.docx",
      );
      const pathReferenceDUVRIPrincipale = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/IN/FASE_1/documentazione/" +
          pratica.cui +
          "_DUVRI.pdf",
      );
      const pathReferenceVerbalePrincipale = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/IN/FASE_1/documentazione/" +
          pratica.cui +
          "_VERBALE.pdf",
      );
      let secondarie: PraticaFlowdy2_Firestore[] =
        this.getPraticheColocateDiUnaPrincipale(pratica.cui);
      // this.logger.info("-> scaricaPacchettoPratica "+ secondarie.length);

      let filesToDownloadPrincipale = [
        pathReferenceRETPrincipale,
        pathReferenceDUVRIPrincipale,
        pathReferenceVerbalePrincipale,
      ];
      let filesToDownloadSecondaria = [];
      const zipPraticaSecondaria = new JSZip();
      let cuiSecondaria: string = "";
      if (secondarie.length > 0) {
        secondarie.forEach((secondaria) => {
          cuiSecondaria = secondaria.cui;
          const pathReferenceRETSecondaria = ref(
            storage,
            "pratiche/scuola/" +
              secondaria.cui +
              "/IN/FASE_1/documentazione/" +
              secondaria.cui +
              "_RET.docx",
          );
          const pathReferenceDUVRISecondaria = ref(
            storage,
            "pratiche/scuola/" +
              secondaria.cui +
              "/IN/FASE_1/documentazione/" +
              secondaria.cui +
              "_DUVRI.pdf",
          );
          const pathReferenceVerbaleSecondaria = ref(
            storage,
            "pratiche/scuola/" +
              secondaria.cui +
              "/IN/FASE_1/documentazione/" +
              secondaria.cui +
              "_VERBALE.pdf",
          );
          filesToDownloadSecondaria.push(pathReferenceRETSecondaria);
          filesToDownloadSecondaria.push(pathReferenceDUVRISecondaria);
          filesToDownloadSecondaria.push(pathReferenceVerbaleSecondaria);
        });
      }

      const downloadPromises = [];
      for (const pathRef of filesToDownloadPrincipale) {
        try {
          const blob = await getBlob(pathRef);
          if (blob) {
            zipPratica.file(pathRef.name, blob);
            downloadPromises.push(Promise.resolve());
          } else {
            this.logger.error(`Errore durante il download di ${pathRef.name}`);
            downloadPromises.push(Promise.reject());
          }
        } catch (error) {
          this.isLoadingResults = false;
          // this.logger.info(pathRef.name);
        }
      }

      // Scarica altri file della pratica principale se presenti
      if (
        pratica.listaAltriFileUploaded &&
        pratica.listaAltriFileUploaded.length > 0
      ) {
        for (let file of pratica.listaAltriFileUploaded) {
          try {
            const pathReferenceDoc = ref(
              storage,
              "pratiche/scuola/" +
                pratica.cui +
                "/IN/FASE_1/documentazione/" +
                file,
            );

            const blobDoc = await getBlob(pathReferenceDoc);
            if (blobDoc) {
              zipPratica.file(`altri/${file}`, blobDoc);
              downloadPromises.push(Promise.resolve());
            } else {
              this.logger.error(`Errore durante il download di ${file}`);
              downloadPromises.push(Promise.reject());
            }
          } catch (error) {
            this.logger.error(`Errore durante il download di ${file}:`, error);
            downloadPromises.push(Promise.reject());
          }
        }
      }

      for (const pathRef of filesToDownloadSecondaria) {
        try {
          const blob = await getBlob(pathRef);
          if (blob) {
            zipPraticaSecondaria.file(pathRef.name, blob);
            downloadPromises.push(Promise.resolve());
          } else {
            this.logger.error(`Errore durante il download di ${pathRef.name}`);
            downloadPromises.push(Promise.reject());
          }
        } catch (error) {
          this.isLoadingResults = false;
          // this.logger.info(pathRef.name);
        }
      }

      // Scarica altri file delle pratiche secondarie se presenti
      if (secondarie.length > 0) {
        for (let secondaria of secondarie) {
          if (
            secondaria.listaAltriFileUploaded &&
            secondaria.listaAltriFileUploaded.length > 0
          ) {
            for (let file of secondaria.listaAltriFileUploaded) {
              try {
                const pathReferenceDoc = ref(
                  storage,
                  "pratiche/scuola/" +
                    secondaria.cui +
                    "/IN/FASE_1/documentazione/" +
                    file,
                );

                const blobDoc = await getBlob(pathReferenceDoc);
                if (blobDoc) {
                  zipPraticaSecondaria.file(`altri/${file}`, blobDoc);
                  downloadPromises.push(Promise.resolve());
                } else {
                  this.logger.error(`Errore durante il download di ${file}`);
                  downloadPromises.push(Promise.reject());
                }
              } catch (error) {
                this.logger.error(
                  `Errore durante il download di ${file}:`,
                  error,
                );
                downloadPromises.push(Promise.reject());
              }
            }
          }
        }
      }

      Promise.all(downloadPromises)
        .then(() => {
          let zipPraticaFinale = new JSZip();

          // Genera il primo zip
          const zip1Promise = zipPratica
            .generateAsync({ type: "blob" })
            .then((blob) => {
              // Aggiunge il primo file zip al contenitore finale
              zipPraticaFinale.file(`${pratica.cui}.zip`, blob);
            });

          // Genera il secondo zip
          const zip2Promise = zipPraticaSecondaria
            .generateAsync({ type: "blob" })
            .then((blob) => {
              // Aggiunge il secondo file zip al contenitore finale
              zipPraticaFinale.file(`${cuiSecondaria}.zip`, blob);
            });

          // Aspetta che entrambi gli zip siano stati aggiunti
          Promise.all([zip1Promise, zip2Promise])
            .then(() => {
              // Genera lo zip finale con entrambi i file
              zipPraticaFinale
                .generateAsync({ type: "blob" })
                .then((finalBlob) => {
                  // Salva lo zip finale
                  saveAs(finalBlob, `${pratica.cui} - ${cuiSecondaria}.zip`);
                  this.isLoadingResults = false;
                })
                .catch((error) =>
                  console.error(
                    "Errore durante la creazione dello zip finale:",
                    error,
                  ),
                );
            })
            .catch((error) =>
              console.error(
                "Errore durante l'aggiunta dei file allo zip finale:",
                error,
              ),
            );
        })
        .catch((error) =>
          console.error("Errore durante l'esecuzione delle promesse:", error),
        );
    }

    this.isLoadingResults = false;
  }

  resettaPratica(pratica: PraticaFlowdy2_Firestore) {
    this.showResettaPratica = true;
    this.selectedPratica = pratica;
  }
  confermaResetPratica() {
    this.isLoadingResults = true;
    this.praticheService.resetFase1(this.selectedPratica.id).subscribe({
      next: (v) => {
        // this.logger.info("NEXT");

        //chiama metodo del magazzino per annullare eventuali movimenti di magazzino
        this.magazzinoService
          .praticaConsegnaAnnulla(this.selectedPratica.id)
          .subscribe({
            next: (res) => {
              this.messageService.add({
                severity: "success",
                summary: "",
                detail: "Pratica resettata!",
                life: 5000,
              });
            },
            error: (e) => {
              this.messageService.add({
                severity: "error",
                summary: "Errore",
                detail:
                  "Errore in fase di annullamento dei movimenti di magazzino",
              });
            },
          });
        this.isLoadingResults = false;
        this.showResettaPratica = false;
        this.selectedPratica = null;
      },
      error: (e) => {
        this.messageService.add({
          life: 10000,
          severity: "error",
          summary: "Errore",
          detail: "Errore in fase di reset della pratica",
        });
        this.isLoadingResults = false;
        this.showResettaPratica = false;
        this.selectedPratica = null;
      },
      complete: () => {
        // this.logger.info("COMPLETE");
      },
    });
  }

  approvaPreventivo(pratica: PraticaFlowdy2_Firestore) {
    this.showConfermaPreventivo = true;
    this.selectedPratica = pratica;
  }

  confermaApprovaPreventivo() {
    this.isLoadingResults = true;
    this.praticheService.approvaPreventivo(this.selectedPratica.id).subscribe({
      next: (v) => {
        this.isLoadingResults = false;
        this.messageService.add({
          severity: "success",
          summary: "",
          detail:
            "Preventivo della pratica " +
            this.selectedPratica.cui +
            " approvato!",
          life: 5000,
        });
        this.showConfermaPreventivo = false;
        this.selectedPratica = null;
        this.loadPratiche();
      },
      error: (e) => {
        this.messageService.add({
          life: 10000,
          severity: "error",
          summary: "Errore",
          detail: "Errore in fase di approvazione del preventivo della pratica",
        });
        this.isLoadingResults = false;
        this.showConfermaPreventivo = false;
        this.selectedPratica = null;
      },
      complete: () => {},
    });
  }

  caricaPreventivo(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogCaricaPreventivoFase1, {
      data: {
        pratica: pratica,
      },
      header:
        "Carica file del PREVENTIVO per la pratica " +
        pratica.cui.toUpperCase(),
      width: "40%",
      height: "40%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((modificaPreventivo) => {
      if (modificaPreventivo && modificaPreventivo.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Preventivo caricato con successo!",
          life: 3000,
        });
      }
    });
  }

  validaConsegna(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogVerificaConsegnaFase1, {
      data: {
        pratica: pratica,
      },
      header:
        "Validazione della consegna della pratica " + pratica.cui.toUpperCase(),
      width: "60%",
      height: "80%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((consegnaValidata) => {
      if (consegnaValidata && consegnaValidata.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Consegna validata con successo!",
          life: 3000,
        });
        this.loadPratiche();
      }
    });
  }

  apriNoteBocciaturaPresidio(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogNoteReworkFase1, {
      data: {
        pratica: pratica,
        isBocciaturaPresidio: true,
      },
      header:
        "Note indicate dal presidio per la bocciatura della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "70%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }

  async scaricaTuttaDocumentazione(pratica: PraticaFlowdy2_Firestore) {
    // this.logger.info("--> scaricaTuttaDocumentazione");
    const storage = getStorage();
    if (pratica.fileRETUploaded) {
      this.scaricaDoc(pratica, "RET");
    }
    if (pratica.fileVerbaleSopralluogoUploaded) {
      this.scaricaDoc(pratica, "VERBALE");
    }
    if (pratica.fileDUVRIUploaded) {
      this.scaricaDoc(pratica, "DUVRI");
    }
    if (pratica.fileAltriUploaded) {
      this.scaricaDoc(pratica, "ALTRI");
    }
  }

  chiediEliminazioneTuttiFileCaricati(
    pratica: PraticaFlowdy2_Firestore,
    tipoFile: string,
  ) {
    this.selectedPratica = pratica;
    if (tipoFile === "ALTRO") {
      this.showEliminaFileALTROConfirmation = true;
    }
  }

  async eliminataTuttiFileAltroCaricati(
    pratica: PraticaFlowdy2_Firestore,
    tipoFile: string,
  ) {
    const storage = getStorage();
    this.isLoadingResults = true;
    let folderPath = "";
    folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_1/documentazione`;

    this.logger.info(
      "--> eliminataTuttiFileAltroCaricati per la pratica " + pratica.cui,
    );
    try {
      const folderRef = ref(storage, folderPath);

      const deletePromises = [];
      let deletedFileCount = 0;
      const praticaRef = this.firestore
        .collection(this.collection_pratiche)
        .doc(pratica.cui);

      // Recupera i file da eliminare dall'array listaAltriFileUploaded del documento Firestore
      const praticaDoc = await praticaRef.get().toPromise();
      const praticaData = praticaDoc.data() as PraticaFlowdy2_Firestore;
      const fileList = praticaData.listaAltriFileUploaded || [];

      for (const fileName of fileList) {
        // Itera sui nomi dei file
        const fileRef = ref(storage, `${folderPath}/${fileName}`);
        this.logger.info(
          "--> eliminataTuttiFileAltroCaricati per la pratica " +
            pratica.cui +
            " - file da eliminare: " +
            fileRef.name,
        );
        deletePromises.push(
          deleteObject(fileRef)
            .then(() => {
              deletedFileCount++;
            })
            .catch((deleteError) => {
              this.messageService.add({
                severity: "error",
                summary: "Errore",
                detail: `Errore durante l'eliminazione del file ${fileName}: ${deleteError.message}`,
                life: 10000,
              });
            }),
        );
      }

      // Aspetta che tutti i file siano cancellati
      await Promise.all(deletePromises);

      // Aggiorna il documento Firestore solo dopo la cancellazione dei file
      const docRef = this.firestore
        .collection(this.collection_pratiche)
        .doc(pratica.cui);
      if (tipoFile === "ALTRO") {
        pratica.fileAltriUploaded = false;
        pratica.listaAltriFileUploaded = [];
      }

      await docRef.update(pratica);

      this.selectedPratica = null;
      // Mostra un messaggio con il numero di file eliminati e il tipo
      this.messageService.add({
        severity: "success",
        summary: "Eliminazione completata",
        detail: `${deletedFileCount} file sono stati eliminati con successo.`,
        life: 10000,
      });
      if (tipoFile === "ALTRO") {
        this.showEliminaFileALTROConfirmation = false;
      }
      this.isLoadingResults = false;
    } catch (error) {
      this.isLoadingResults = false;
      this.messageService.add({
        severity: "error",
        summary: "Attenzione!",
        detail: `Errore nel recupero dei file: ${error.message}`,
      });
    }
  }

  async scaricaDoc(pratica: PraticaFlowdy2_Firestore, tipoDocumento: string) {
    const storage = getStorage();
    if (tipoDocumento !== "ALTRI") {
      if (tipoDocumento === "RET") {
        let pathReferenceDoc = ref(
          storage,
          "pratiche/scuola/" +
            pratica.cui +
            "/IN/FASE_1/documentazione/" +
            pratica.cui +
            "_RET.docx",
        );
        const blobDoc = await getBlob(pathReferenceDoc);
        saveAs(blobDoc, pratica.cui + "_RET.docx");
      } else {
        let file: string = tipoDocumento === "DUVRI" ? "DUVRI" : "VERBALE";
        let pathReferenceDoc = ref(
          storage,
          "pratiche/scuola/" +
            pratica.cui +
            "/IN/FASE_1/documentazione/" +
            pratica.cui +
            "_" +
            file +
            ".pdf",
        );
        const blobDoc = await getBlob(pathReferenceDoc);
        saveAs(blobDoc, pratica.cui + "_" + file + ".pdf");
      }
    } else {
      if (
        pratica.listaAltriFileUploaded &&
        pratica.listaAltriFileUploaded.length > 0
      ) {
        for (let file of pratica.listaAltriFileUploaded) {
          this.isLoadingResults = true;
          const pathReferenceDoc = ref(
            storage,
            "pratiche/scuola/" +
              pratica.cui +
              "/IN/FASE_1/documentazione/" +
              file,
          );

          const blobDoc = await getBlob(pathReferenceDoc);
          saveAs(blobDoc, file);
        }
      }
    }

    this.isLoadingResults = false;
  }

  caricaDocumento(pratica: PraticaFlowdy2_Firestore, tipoDocumento: string) {
    let header = "Caricamento ";
    if (tipoDocumento === "ALTRI") {
      header +=
        "di ALTRI DOCUMENTI per la pratica " + pratica.cui.toUpperCase();
    } else {
      header += "del";
      if (tipoDocumento === "RET") {
        header += "la";
      }
      header +=
        " " + tipoDocumento + " per la pratica " + pratica.cui.toUpperCase();
    }

    this.ref = this.dialogService.open(DialogCaricaDocumentoFase1, {
      data: {
        pratica: pratica,
        tipoDoc: tipoDocumento,
      },
      header: header,
      width: "50%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((caricamentoDoc) => {
      if (caricamentoDoc && caricamentoDoc.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail:
            tipoDocumento !== "ALTRI"
              ? tipoDocumento + " caricato con successo!"
              : "Altro documento caricato con successo",
          life: 3000,
        });
      }
    });
  }

  apriNoteRework(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogNoteReworkFase1, {
      data: {
        pratica: pratica,
      },
      header: "Note per il REWORK della pratica " + pratica.cui.toUpperCase(),
      width: "60%",
      height: "70%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }
  apriNoteRespingimento(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogNoteReworkFase1, {
      data: {
        pratica: pratica,
        isRespigimento: true,
      },
      header:
        "Note relative al RESPINGIMENTO della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "70%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }

  consegnaPratica(pratica: PraticaFlowdy2_Firestore) {
    this.showDeliverConfirmation = true;
    this.selectedPratica = pratica;
  }

  confermaConsegnaPratica() {
    this.isLoadingResults = true;
    this.praticheService.consegnaFase1(this.selectedPratica.id).subscribe({
      next: (v) => {
        this.isLoadingResults = false;
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Pratica consegnata!",
          life: 5000,
        });
        this.showDeliverConfirmation = false;
        this.selectedPratica = null;
        this.loadPratiche();
      },
      error: (e) => {
        this.messageService.add({
          life: 10000,
          severity: "error",
          summary: "Errore",
          detail: "Errore in fase di consegna della pratica",
        });
        this.isLoadingResults = false;
        this.showDeliverConfirmation = false;
        this.selectedPratica = null;
      },
      complete: () => {},
    });
  }

  annullaConsegna(pratica: PraticaFlowdy2_Firestore) {
    this.showAnnullaConsegnaConfirmation = true;
    this.selectedPratica = pratica;
  }
  confermaAnnullamentoConsegnaPratica() {
    this.isLoadingResults = true;
    this.praticheService
      .annullaConsegnaFase1(this.selectedPratica.id)
      .subscribe({
        next: (v) => {
          this.isLoadingResults = false;
          this.messageService.add({
            severity: "success",
            summary: "",
            detail: "Annullamento consegna avvenuto con successo!",
            life: 5000,
          });
          this.showAnnullaConsegnaConfirmation = false;
          this.selectedPratica = null;
          this.isLoadingResults = false;
          this.loadPratiche();
        },
        error: (e) => {
          this.messageService.add({
            life: 10000,
            severity: "error",
            summary: "Errore",
            detail:
              "Errore in fase di annullamento della consegna della pratica",
          });
          this.isLoadingResults = false;
          this.showAnnullaConsegnaConfirmation = false;
          this.selectedPratica = null;
          this.isLoadingResults = false;
        },
        complete: () => {},
      });
  }

  async scaricaPreventivo(pratica: PraticaFlowdy2_Firestore) {
    const storage = getStorage();
    this.isLoadingResults = true;
    const pathReferenceFilePreventivo = ref(
      storage,
      "pratiche/scuola/" +
        pratica.cui +
        "/IN/FASE_1/preventivo/" +
        pratica.cui +
        ".pdf",
    );

    const blobPreventivo = await getBlob(pathReferenceFilePreventivo);
    saveAs(blobPreventivo, "preventivo_opere_extra_" + pratica.cui + ".pdf");
    this.isLoadingResults = false;
  }

  checkIfDeliverable(pratica: PraticaFlowdy2_Firestore): boolean {
    if (!pratica.colocata || pratica.colocataRuolo === "SECONDARIA") {
      // this.logger.info("-> checkIfDeliverable SU NON COLOCATA O SU SECONDARIA");

      return this.checkConsegnabile(pratica);
    } else {
      //// this.logger.info("-> checkIfDeliverable SU PRINCIPALE "+ pratica.cui);
      if (!this.checkConsegnabile(pratica)) {
        // this.logger.info("-> checkIfDeliverable SU PRINCIPALE "+ pratica.cui + " - NON ANCORA CONSEGNABILE");
        return false;
      } else {
        if (
          pratica.colocataRuolo === "PRINCIPALE" &&
          this.checkCodiceInvioUgualeColocate(pratica)
        ) {
          // this.logger.info("-> checkIfDeliverable SU PRINCIPALE "+ pratica.cui + " STESSO CODICE INVIO DELLE SECONDARIE");

          let praticheCololcate: PraticaFlowdy2_Firestore[] =
            this.getPraticheColocateDiUnaPrincipale(pratica.cui);
          let colocataConsegnabile: boolean = false;
          if (
            (pratica.statoFlowdyFase1 === "SOPRALLUOGO EFFETTUATO" ||
              pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" ||
              pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO") &&
            pratica.sopralluogoOk
          ) {
            /* pratica.fotoCPEUploaded &&
                  pratica.fileVerbaleAttivazioneUploaded &&
                  pratica.filePingTestUploaded && pratica.numeroFilePingtestUploaded > 0 &&
                  pratica.fileSpeedTestUploaded && pratica.numeroFileSpeedtestUploaded > 0 
            ){ */
            praticheCololcate.forEach((cololcata) => {
              colocataConsegnabile = this.checkConsegnabile(cololcata);
            });

            return colocataConsegnabile;
          }
        } else {
          // this.logger.info("-> checkIfDeliverable SU COLOCATA PRINCIPALE "+ pratica.cui + " CODICE INVIO DELLE SECONDARIE DIVERSO ");

          return this.checkConsegnabile(pratica);
        }
      }
      return false;

      /* if(pratica.colocataRuolo==='PRINCIPALE' && this.checkCodiceInvioUgualeColocate(pratica)){
          if(this.checkConsegnabile(pratica)){
            let praticheCololcate:PraticaFlowdy2_Firestore[] = this.getPraticheColocateDiUnaPrincipale(pratica.cui);
            let cololcataConsegnabile:boolean = false;
            if( (pratica.statoFlowdyFase1 === 'SOPRALLUOGO EFFETTUATO' || pratica.statoFlowdyFase1 === 'PREVENTIVO IN ATTESA' || pratica.statoFlowdyFase1 === 'PREVENTIVO APPROVATO') && pratica.sopralluogoOk){
              praticheCololcate.forEach(cololcata => {
                cololcataConsegnabile = this.checkConsegnabile(cololcata);
              });
  
              return cololcataConsegnabile;
            }
          }
          return false;
        }else{
          return this.checkConsegnabile(pratica);
        } */
    }
  }

  checkConsegnabile(pratica: PraticaFlowdy2_Firestore): boolean {
    let consegnabile: boolean = false;
    if (
      (pratica.statoFlowdyFase1 === "SOPRALLUOGO EFFETTUATO" ||
        pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" ||
        pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO") &&
      pratica.sopralluogoOk
    ) {
      if (pratica.opereExtra) {
        if (pratica.preventivo && pratica.filePreventivoUploaded) {
          if (
            pratica.fileRETUploaded &&
            pratica.fileDUVRIUploaded &&
            pratica.fileVerbaleSopralluogoUploaded
          ) {
            consegnabile = true;
          }
        }
      } else {
        // this.logger.info("-> checkConsegnabile "+  pratica.cui+  " " + pratica.fileRETUploaded + " "+ pratica.fileDUVRIUploaded + " "+ pratica.fileVerbaleSopralluogoUploaded);

        if (
          pratica.fileRETUploaded &&
          pratica.fileDUVRIUploaded &&
          pratica.fileVerbaleSopralluogoUploaded
        ) {
          consegnabile = true;
        }
      }
    }
    // this.logger.info("->  "+ pratica.cui + " CONSEGNABILE? "+ consegnabile);

    return consegnabile;
  }

  modificaPreventivo(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogModificaPreventivoFase1, {
      data: {
        pratica: pratica,
      },
      header: "Modifica PREVENTIVO per la pratica " + pratica.cui.toUpperCase(),
      width: "50%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((modificaPreventivo) => {
      if (modificaPreventivo && modificaPreventivo.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Preventivo modificato con successo!",
          life: 3000,
        });
        this.loadPratiche();
      }
    });
  }

  assegnaODA(pratica: PraticaFlowdy2_Firestore) {
    const localizzazione: string =
      pratica.cui.split("-")[1] === "LIG"
        ? "LIGURIA"
        : pratica.cui.split("-")[1] === "PIE"
          ? "PIEMONTE"
          : "TOSCANA";
    this.isLoadingResults = true;
    this.odaService
      .getDisponibiliPerAzienda(
        pratica.idAziendaFase1,
        pratica.bando,
        localizzazione,
      )
      .subscribe({
        next: (v) => {
          // this.logger.info(JSON.stringify(v));
          if (!v || v.length == 0) {
            this.isLoadingResults = false;
            this.messageService.add({
              life: 10000,
              severity: "warn",
              summary: "ATTENZIONE",
              detail:
                "Nessun ODA disponibile per l'azienda " +
                pratica.azienda +
                " ed il bando 2",
            });
          } else {
            this.isLoadingResults = false;
            this.ref = this.dialogService.open(DialogAssegnaOdaFase1, {
              data: {
                pratica: pratica,
                listaOda: v,
              },
              header: "Assegna ODA alla pratica " + pratica.cui.toUpperCase(),
              width: "50%",
              height: "55%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.ref.onClose.subscribe((confermaAssegnazioneODA) => {
              if (confermaAssegnazioneODA && confermaAssegnazioneODA.success) {
                this.messageService.add({
                  severity: "success",
                  summary: "",
                  detail: "ODA assegnato con successo!",
                  life: 3000,
                });
                this.loadPratiche();
              }
            });
          }
        },
        error: (e) => {
          this.messageService.add({
            life: 10000,
            severity: "error",
            summary: "Errore",
            detail:
              "Errore in fase di recupero dell'oda da assegnare alla pratica",
          });
          this.isLoadingResults = false;
        },
        complete: () => {
          this.isLoadingResults = false;
        },
      });
  }

  comunicaEsitoSopralluogo(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogEsitoSopralluogoFase1, {
      data: {
        pratica: pratica,
      },
      header:
        "Comunica esito sopralluogo per la pratica " +
        pratica.cui.toUpperCase(),
      width: "70%",
      height: "65%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((confermaEsito) => {
      if (confermaEsito && confermaEsito.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Sopralluogo comunicato con successo!",
          life: 3000,
        });
        this.loadPratiche();
      }
    });
  }

  openPrendiInCarico(pratica: PraticaFlowdy2_Firestore): void {
    this.confirmationService.confirm({
      message: `Confermi di voler prendere in carico la pratica ${pratica.cui}?`,
      header: "Presa in carico",
      icon: "pi pi-File-import",
      acceptLabel: "CONFERMA",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: () => {
        this.isLoadingResults = true;
        if (this.isImpresa) {
          let utente: Utente = new Utente();
          utente.id = Number(localStorage.getItem("idUtente"));
          this.praticheService
            .utentePrendeInCaricoFase1(this.selectedPratica.id, utente)
            .subscribe({
              next: (v) => {
                this.isLoadingResults = false;
                this.messageService.add({
                  severity: "success",
                  summary: "",
                  detail: "Pratica presa in carico con successo!",
                  life: 5000,
                });
                this.loadPratiche();
              },
              error: (e) => {
                this.messageService.add({
                  life: 10000,
                  severity: "error",
                  summary: "Errore",
                  detail: "Errore in fase di presa in carico della pratica",
                });
                this.isLoadingResults = false;
              },
              complete: () => {},
            });
        } else if (this.isPresidioSF) {
          if (pratica.statoFlowdyFase1 === "DA ASSEGNARE") {
            let utente: Utente = new Utente();
            utente.id = Number(localStorage.getItem("idUtente"));
            this.praticheService
              .utentePrendeInCaricoFase1(this.selectedPratica.id, utente)
              .subscribe({
                next: (v) => {
                  this.isLoadingResults = false;
                  this.messageService.add({
                    severity: "success",
                    summary: "",
                    detail: "Pratica presa in carico con successo!",
                    life: 5000,
                  });
                  this.loadPratiche();
                },
                error: (e) => {
                  this.messageService.add({
                    life: 10000,
                    severity: "error",
                    summary: "Errore",
                    detail: "Errore in fase di presa in carico della pratica",
                  });
                  this.isLoadingResults = false;
                },
                complete: () => {},
              });
          } else {
            this.praticheService
              .presidioPrendeInCaricoFase1(this.selectedPratica.id)
              .subscribe({
                next: (v) => {
                  this.isLoadingResults = false;
                  this.messageService.add({
                    severity: "success",
                    summary: "",
                    detail: "Pratica presa in carico con successo!",
                    life: 5000,
                  });
                  this.loadPratiche();
                },
                error: (e) => {
                  this.messageService.add({
                    life: 10000,
                    severity: "error",
                    summary: "Errore",
                    detail: "Errore in fase di presa in carico della pratica",
                  });
                  this.isLoadingResults = false;
                },
                complete: () => {},
              });
          }
        }
      },
      reject: () => {
        //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
      },
    });
  }

  onMostraCompletatiChange(newValue: boolean): void {
    this.mostraPraticheCompletate = newValue;
    this.loadPratiche();
  }

  onMostraPreventiviApprovatiChange(newValue: boolean): void {
    this.mostraPreventiviApprovati = newValue;
    this.loadPratiche();
  }

  loadPratiche() {
    this.isLoadingResults = true;
    const collectionRef = this.firestore.collection(
      this.collection_pratiche,
    ).ref;
    let query;

    if (this.isPresidioTIM) {
      if (this.filterIsSet) {
        if (this.filtroLotto) {
          this.logger.info(
            "[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 FILTRO PER LOTTO " +
              this.filtroLotto,
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
            .orderBy("codiceStatoInfratelFase1");
        } else if (this.filtroStatoInfratel) {
          if (this.filtroLottoPerFase) {
            this.logger.info(
              "[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel +
                " E LOTTO " +
                this.filtroLottoPerFase,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("codiceStatoInfratelFase1");
          } else {
            this.logger.info(
              "[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 FILTRO PER STATO INFRATEL " +
                this.filtroStatoInfratel,
            );

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .orderBy("codiceStatoInfratelFase1");
          }
        } else if (this.filtroInLavorazione) {
          this.logger.info(
            "[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 FILTRO PER IN LAVORAZIONE ",
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .orderBy("codiceStatoInfratelFase1");
        } else if (this.filtroOda) {
          this.logger.info(
            "[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 FILTRO PER ODA " +
              this.filtroOda,
          );
          if (this.filtroDaPagare) {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("numeroOda", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase1");
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("numeroOda", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase1");
          }
        } else if (this.filtroImpresa) {
          this.logger.info(
            "[PRATICHE FASE 1 LOADING PRATICHE FASE 1 FILTRO PER IMPRESA " +
              this.filtroImpresa,
          );
          if (!this.filtroRegione) {
            if (this.filtroStatoFlowdy) {
              query = collectionRef
                .where("bando", "==", "BANDO 2")
                .where("idAziendaFase1", "==", Number(this.filtroImpresa))
                .where("statoFlowdyFase1", "==", this.filtroStatoFlowdy)
                .orderBy("codiceStatoInfratelFase1");
            } else {
              query = collectionRef
                .where("bando", "==", "BANDO 2")
                .where("idAziendaFase1", "==", Number(this.filtroImpresa))
                .orderBy("codiceStatoInfratelFase1");
            }
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("idAziendaFase1", "==", Number(this.filtroImpresa))
              .where("regione", "==", this.filtroRegione)
              .orderBy("codiceStatoInfratelFase1");
          }
        }
      } else {
        //  this.logger.info("[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 SENZA FILTRI");

        if (!this.mostraPraticheCompletate) {
          this.logger.info(
            "[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 SENZA FILTRI E NON COMPLETATE",
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .orderBy("codiceStatoInfratelFase1");
        } else {
          this.logger.info(
            "[PRATICHE FASE 1] PRESIDIO TIM LOADING PRATICHE FASE 1 SENZA FILTRI E COMPLETATE",
          );
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .orderBy("codiceStatoInfratelFase1");
        }
      }
    } else if (this.isImpresa) {
      this.logger.info(
        "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 PER IMPRESA " +
          this.userService.getUser().azienda.id,
      );
      if (this.filterIsSet) {
        if (this.filtroLotto) {
          // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER LOTTO "+ this.filtroLotto);
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
            .where(
              "idAziendaFase1",
              "==",
              this.userService.getUser().azienda.id,
            )
            .where("codiceStatoInfratelFase1", "!=", "1-6")
            .orderBy("codiceStatoInfratelFase1");
        } else if (this.filtroStatoInfratel) {
          if (this.filtroLottoPerFase) {
            // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where(
                "idAziendaFase1",
                "==",
                this.userService.getUser().azienda.id,
              )
              .where("codiceStatoInfratelFase1", "==", this.filtroStatoInfratel)
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("codiceStatoInfratelFase1");
          } else {
            // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where(
                "idAziendaFase1",
                "==",
                this.userService.getUser().azienda.id,
              )
              .where("codiceStatoInfratelFase1", "==", this.filtroStatoInfratel)
              .orderBy("codiceStatoInfratelFase1");
          }
        } else if (this.filtroInLavorazione) {
          // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER IN LAVORAZIONE ");

          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where(
              "idAziendaFase1",
              "==",
              this.userService.getUser().azienda.id,
            )
            .where("codiceStatoInfratelFase1", "!=", "1-6")
            .orderBy("codiceStatoInfratelFase1");
        } else if (this.filtroOda) {
          // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER ODA "+ this.filtroOda);
          if (this.filtroDaPagare) {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where(
                "idAziendaFase1",
                "==",
                this.userService.getUser().azienda.id,
              )
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("importoPagatoFase1", "==", null)
              .orderBy("codiceStatoInfratelFase1");
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where(
                "idAziendaFase1",
                "==",
                this.userService.getUser().azienda.id,
              )
              .where("numeroOda", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase1");
          }
        } else if (this.filtroPratica) {
          //this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER PRATICA "+ this.filtroPratica );
          if (this.filtroPratica) {
            query = collectionRef
              .where("cui", ">=", this.filtroPratica)
              .where("cui", "<=", this.filtroPratica + "\uf8ff");
          } else {
            query = collectionRef;
          }
        } else if (this.filtroImpresa) {
          this.logger.info(
            "[PRATICHE FASE 2 LOADING PRATICHE FASE 1 FILTRO PER IMPRESA " +
              this.filtroImpresa,
          );
          if (!this.filtroRegione) {
            if (this.filtroStatoFlowdy) {
              query = collectionRef
                .where("bando", "==", "BANDO 2")
                .where("idAziendaFase1", "==", Number(this.filtroImpresa))
                .where("statoFlowdyFase1", "==", this.filtroStatoFlowdy)
                .orderBy("codiceStatoInfratelFase1");
            } else {
              query = collectionRef
                .where("bando", "==", "BANDO 2")
                .where("idAziendaFase1", "==", Number(this.filtroImpresa))
                .orderBy("codiceStatoInfratelFase1");
            }
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("idAziendaFase1", "==", Number(this.filtroImpresa))
              .where("regione", "==", this.filtroRegione)
              .orderBy("codiceStatoInfratelFase1");
          }
        }
      } else {
        // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 SENZA FILTRI");

        if (!this.mostraPraticheCompletate) {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where(
              "idAziendaFase1",
              "==",
              this.userService.getUser().azienda.id,
            )
            .where("codiceStatoInfratelFase1", "!=", "1-6")
            .orderBy("codiceStatoInfratelFase1");
        } else {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where(
              "idAziendaFase1",
              "==",
              this.userService.getUser().azienda.id,
            )
            .orderBy("codiceStatoInfratelFase1");
        }
      }
    } else if (this.isPM) {
      // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE PER PM FASE 1 ");
      if (this.mostraPreventiviApprovati) {
        query = collectionRef
          .where("bando", "==", "BANDO 2")
          .where("codiceStatoInfratelFase1", "!=", "1-6")
          .where("opereExtra", "==", true)
          //.where("statoPreventivo", "==",'IN ATTESA' )
          .orderBy("codiceStatoInfratelFase1")
          .orderBy("cui");
      } else {
        query = collectionRef
          .where("bando", "==", "BANDO 2")
          .where("codiceStatoInfratelFase1", "!=", "1-6")
          .where("opereExtra", "==", true)
          // .where("statoPreventivo", "!=",'APPROVATO' )
          .orderBy("codiceStatoInfratelFase1")
          .orderBy("cui");
      }
    } else if (
      this.isPresidioSF ||
      this.isAdmin ||
      this.isSuperAdmin ||
      this.isDirigenteFirmaPacchetti ||
      this.isDemo
    ) {
      if (this.filterIsSet) {
        this.logger.info(
          "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO filterIsSet  " +
            this.filterIsSet,
        );
        if (this.filtroLotto) {
          // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER LOTTO "+ this.filtroLotto);
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("lotto", "==", this.filtroLotto)
            .where("codiceStatoInfratelFase1", "!=", "1-6")
            .orderBy("codiceStatoInfratelFase1");
        } else if (this.filtroStatoInfratel) {
          if (this.filtroLottoPerFase) {
            // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", this.filtroStatoInfratel)
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("codiceStatoInfratelFase1");
          } else {
            // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", this.filtroStatoInfratel)
              .orderBy("codiceStatoInfratelFase1");
          }
        } else if (this.filtroInLavorazione) {
          // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER IN LAVORAZIONE ");

          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("codiceStatoInfratelFase1", "!=", "1-6")
            .orderBy("codiceStatoInfratelFase1");
        } else if (this.filtroOda) {
          // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER ODA "+ this.filtroOda);
          if (this.filtroDaPagare) {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("importoPagatoFase1", "==", null)
              .orderBy("codiceStatoInfratelFase1");
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("numeroOda", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase1");
          }
        } else if (this.filtroImpresa) {
          // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER IMPRESA "+ this.filtroImpresa );
          if (!this.filtroRegione) {
            if (this.filtroStatoFlowdy) {
              this.logger.info(
                "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER IMPRESA " +
                  this.filtroImpresa +
                  " FILTRO PER STATO FLOWDY " +
                  this.filtroStatoFlowdy,
              );

              query = collectionRef
                .where("bando", "==", "BANDO 2")
                .where("idAziendaFase1", "==", Number(this.filtroImpresa))
                .where("statoFlowdyFase1", "==", this.filtroStatoFlowdy)
                .orderBy("codiceStatoInfratelFase1");
            } else {
              this.logger.info(
                "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER IMPRESA " +
                  this.filtroImpresa +
                  " SENZA FILTRO PER STATO FLOWDY ",
              );
              query = collectionRef
                .where("bando", "==", "BANDO 2")
                .where("idAziendaFase1", "==", Number(this.filtroImpresa))
                .orderBy("codiceStatoInfratelFase1");
            }
          } else {
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("idAziendaFase1", "==", Number(this.filtroImpresa))
              .where("regione", "==", this.filtroRegione)
              .orderBy("codiceStatoInfratelFase1");
          }
        } else if (this.filtroPratica) {
          this.logger.info(
            "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER PRATICA " +
              this.filtroPratica,
          );
          if (this.filtroPratica) {
            query = collectionRef
              .where("cui", ">=", this.filtroPratica)
              .where("cui", "<=", this.filtroPratica + "\uf8ff");
          } else {
            query = collectionRef;
          }
        } else if (this.filtroStatoSopralluogo) {
          if (this.filtroRegione) {
            this.logger.info(
              "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO SOPRALLUOGO " +
                this.filtroStatoSopralluogo +
                " FILTRO PER REGIONE " +
                this.filtroRegione,
            );
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .where("regione", "==", this.filtroRegione)
              .orderBy("codiceStatoInfratelFase1");
          } else {
            this.logger.info(
              "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO SOPRALLUOGO " +
                this.filtroStatoSopralluogo,
            );
            query = collectionRef
              .where("bando", "==", "BANDO 2")
              .orderBy("codiceStatoInfratelFase1");
          }
        } else if (this.filtroStatoFlowdy) {
          if (!this.filtroRegione) {
            this.logger.info(
              "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO FLOWDY " +
                this.filtroStatoFlowdy,
            );
            query = collectionRef
              .where("statoFlowdyFase1", "==", this.filtroStatoFlowdy)
              .where("bando", "==", "BANDO 2")
              .orderBy("statoFlowdyFase1")
              .orderBy("codiceStatoInfratelFase1");
          } else {
            this.logger.info(
              "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO FLOWDY " +
                this.filtroStatoFlowdy +
                " FILTRO PER REGIONE " +
                this.filtroRegione,
            );
            query = collectionRef
              .where("statoFlowdyFase1", "==", this.filtroStatoFlowdy)
              .where("regione", "==", this.filtroRegione)
              .orderBy("statoFlowdyFase1")
              .orderBy("codiceStatoInfratelFase1");
          }
        }
      } else {
        // this.logger.info("[PRATICHE FASE 1] LOADING PRATICHE FASE 1 SENZA FILTRI");

        if (!this.mostraPraticheCompletate) {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            .where("codiceStatoInfratelFase1", "!=", "1-6")
            .orderBy("codiceStatoInfratelFase1");
        } else {
          query = collectionRef
            .where("bando", "==", "BANDO 2")
            //.where("codiceStatoInfratelFase1", "==", "1-6")
            .orderBy("codiceStatoInfratelFase1");
        }
      }
    }

    onSnapshot(query, (qs) => {
      this.pratiche = [];
      this.praticheFiltrate = [];
      this.praticheSenzaEscludereLeKO = [];

      this.logger.info(
        "[PRATICHE FASE 1] PRATICHE FASE 1 CARICATE " + qs.docs.length,
      );

      qs.forEach((doc) => {
        let pratica = doc.data() as PraticaFlowdy2_Firestore;

        if (this.isPresidioTIM) {
          if (this.filtroStatoInfratel) {
            if (pratica.codiceStatoInfratelFase1 === this.filtroStatoInfratel) {
              this.praticheSenzaEscludereLeKO.push(pratica);
              this.pratiche.push(pratica);
              this.praticheFiltrate.push(pratica);
            }
          } else {
            if (!this.mostraPraticheCompletate) {
              if (
                pratica.codiceStatoInfratelFase1 === "1-3" ||
                pratica.codiceStatoInfratelFase1 === "1-4"
              ) {
                //   this.logger.info("[PRATICHE FASE 1] pratica  "+ pratica.cui+  " " + pratica.codiceStatoInfratelFase1 + " -> " + this.mostraPraticheCompletate);

                this.pratiche.push(pratica);
                this.praticheFiltrate.push(pratica);
                this.praticheSenzaEscludereLeKO.push(pratica);
              }
            } else {
              if (
                pratica.codiceStatoInfratelFase1 === "1-3" ||
                pratica.codiceStatoInfratelFase1 === "1-4" ||
                pratica.codiceStatoInfratelFase1 === "1-6"
              ) {
                this.pratiche.push(pratica);
                this.praticheFiltrate.push(pratica);
                this.praticheSenzaEscludereLeKO.push(pratica);
              }
            }
          }
        } else if (this.isPM) {
          if (this.mostraPreventiviApprovati) {
            this.pratiche.push(pratica);
            this.praticheFiltrate.push(pratica);
          } else {
            if (pratica.statoPreventivo !== "APPROVATO") {
              this.pratiche.push(pratica);
              this.praticheFiltrate.push(pratica);
            }
          }
        } else {
          // this.praticheSenzaEscludereLeKO.push(pratica);
          if (
            this.filterIsSet &&
            this.filtroImpresa &&
            !this.filtroStatoSopralluogo
          ) {
            this.logger.info(
              "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER IMPRESA " +
                this.filtroImpresa +
                " SENZA FILTRO PER STATO SOPRALLUOGO ",
            );
            // if((pratica.idAziendaFase1 && pratica.idAziendaFase1 === Number(this.filtroImpresa)) ) {
            this.pratiche.push(pratica);
            this.praticheFiltrate.push(pratica);
            this.praticheSenzaEscludereLeKO.push(pratica);
            // }
          } else if (
            this.filterIsSet &&
            !this.filtroImpresa &&
            this.filtroStatoSopralluogo
          ) {
            this.logger.info(
              "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO SOPRALLUOGO " +
                this.filtroStatoSopralluogo,
            );
            switch (this.filtroStatoSopralluogo) {
              case "noSopralluogo":
                //!pratica.showFase2 &&
                if (
                  pratica.statoFlowdyFase1 === "IN ATTESA ODA" ||
                  pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
                  pratica.statoFlowdyFase1 === "ASSEGNATA"
                ) {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                  this.praticheSenzaEscludereLeKO.push(pratica);
                }
                break;
              case "noSopralluogoPF":
                //!pratica.showFase2 &&
                if (!pratica.dataSopralluogo) {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                  this.praticheSenzaEscludereLeKO.push(pratica);
                }
                break;
              case "sopralluogoPianificato":
                //!pratica.showFase2 &&
                if (pratica.statoFlowdyFase1 === "SOPRALLUOGO PIANIFICATO") {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                  this.praticheSenzaEscludereLeKO.push(pratica);
                }
                break;
              case "sopralluogoEseguito":
                //!pratica.showFase2 &&
                if (pratica.sopralluogoOk) {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                  this.praticheSenzaEscludereLeKO.push(pratica);
                }
                break;
              case "sopralluogoKO":
                //!pratica.showFase2 &&
                if (pratica.sopralluogoOk === false) {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                  this.praticheSenzaEscludereLeKO.push(pratica);
                }
                break;
              default:
                this.pratiche.push(pratica);
                this.praticheFiltrate.push(pratica);
                break;
            }
          } else if (
            this.filterIsSet &&
            this.filtroImpresa &&
            this.filtroStatoSopralluogo
          ) {
            this.logger.info(
              "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER IMPRESA " +
                this.filtroImpresa +
                " FILTRO PER STATO SOPRALLUOGO " +
                this.filtroStatoSopralluogo,
            );
            switch (this.filtroStatoSopralluogo) {
              case "noSopralluogo":
                //!pratica.showFase2 &&
                if (
                  pratica.statoFlowdyFase1 === "IN ATTESA ODA" ||
                  pratica.statoFlowdyFase1 === "DA ASSEGNARE" ||
                  pratica.statoFlowdyFase1 === "ASSEGNATA"
                ) {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                  this.praticheSenzaEscludereLeKO.push(pratica);
                }
                break;
              case "noSopralluogoPF":
                //!pratica.showFase2 &&
                if (!pratica.dataSopralluogo) {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                  this.praticheSenzaEscludereLeKO.push(pratica);
                }
                break;
              case "sopralluogoPianificato":
                //!pratica.showFase2 &&
                if (pratica.statoFlowdyFase1 === "SOPRALLUOGO PIANIFICATO") {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                  this.praticheSenzaEscludereLeKO.push(pratica);
                }
                break;
              case "sopralluogoEseguito":
                //!pratica.showFase2 &&
                if (pratica.sopralluogoOk) {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                  this.praticheSenzaEscludereLeKO.push(pratica);
                }
                break;
              case "sopralluogoKO":
                //!pratica.showFase2 &&
                if (pratica.sopralluogoOk === false) {
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                  this.praticheSenzaEscludereLeKO.push(pratica);
                }
                break;
              default:
                this.pratiche.push(pratica);
                this.praticheFiltrate.push(pratica);
                break;
            }
          } else if (this.filterIsSet && this.filtroStatoFlowdy) {
            this.logger.info(
              "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 FILTRO PER STATO FLOWDY " +
                this.filtroStatoFlowdy,
            );
            if (pratica.statoFlowdyFase1 === this.filtroStatoFlowdy) {
              this.pratiche.push(pratica);
              this.praticheFiltrate.push(pratica);
              this.praticheSenzaEscludereLeKO.push(pratica);
            }
          } else {
            this.logger.info(
              "[PRATICHE FASE 1] LOADING PRATICHE FASE 1 SENZA FILTRI ",
            );
            //if(pratica.statoFlowdyFase1!=='SOPRALLUOGO KO'){
            this.pratiche.push(pratica);
            this.praticheFiltrate.push(pratica);
            this.praticheSenzaEscludereLeKO.push(pratica);
            // }
          }
          /*  if(pratica.statoFlowdyFase1!=='SOPRALLUOGO KO'){
                this.pratiche.push(pratica);
                this.praticheFiltrate.push(pratica);
              } */
        }
      });
      this.filtraPratiche(null);
      this.isLoadingResults = false;
    });
  }

  rifiutaConsegna(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogPresidioTIMRifiutaPratica, {
      data: {
        pratica: pratica,
        fase: "1",
      },
      header:
        "Rifiuta la consegna della FASE 1 della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "50%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((rifiutoOK) => {
      if (rifiutoOK && rifiutoOK.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Consegna rifiutata !",
          life: 3000,
        });
      }
    });
  }

  comunicaInvioInfratelPratica(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogInvioInfratel, {
      data: {
        pratica: pratica,
        fase: 1,
      },
      header:
        "Comunicazione invio ad INFRATEL della FASE 1 della pratica " +
        pratica.cui.toUpperCase(),
      width: "50%",
      height: "80%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((invioFase1) => {
      if (invioFase1 && invioFase1.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Invio della pratica ad INFRATEL comuinicato!",
          life: 3000,
        });
      }
    });
  }

  deveLampeggiare(pratica: PraticaFlowdy2_Firestore): boolean {
    const oggi = new Date();
    const dataRisposta = pratica.dataRispostaInfratelFase1.toDate();
    const diffTime = Math.abs(oggi.getTime() - dataRisposta.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays >= 10) {
      return true;
    }
    return false;
  }

  getTooltipRifiutata(pratica: PraticaFlowdy2_Firestore): string {
    let messaggio: string = "Pratica rifiutata da ";
    if (pratica.dataRispostaInfratelFase1) {
      const oggi = new Date();
      const dataRisposta = pratica.dataRispostaInfratelFase1.toDate(); // Converte il Firestore Timestamp in un oggetto Date
      const diffTime = Math.abs(oggi.getTime() - dataRisposta.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Converte il tempo in giorni
      messaggio += `${diffDays} giorni. Ne mancano ${30 - diffDays} alla penale riguardante la bocciatura infratel`;
    } else {
      messaggio += "un numero sconosciuto di giorni";
    }
    return messaggio;
  }

  getSopralluogoTooltip(pratica: PraticaFlowdy2_Firestore): string {
    if (!pratica.dataSopralluogo) {
      return "Da effettuarsi";
    } else {
      if (pratica.sopralluogoOk) {
        return (
          "Eseguito con successo in data " +
          this.utilService.formattaDataDaTimestampFirestore(
            pratica.dataSopralluogo,
          )
        );
      } else {
        if (pratica.statoFlowdyFase1 === "SOPRALLUOGO PIANIFICATO") {
          return (
            "Pianificato per il giorno " +
            this.utilService.formattaDataDaTimestampFirestore(
              pratica.dataSopralluogo,
            )
          );
        }
        return (
          "Eseguito in data " +
          this.utilService.formattaDataDaTimestampFirestore(
            pratica.dataSopralluogo,
          ) +
          " con esito KO!"
        );
      }
    }
  }

  getPreventivoTooltip(pratica: PraticaFlowdy2_Firestore): string {
    return (
      "Presentato il " +
      this.utilService.formattaDataDaTimestampFirestore(
        pratica.dataPresentazionePreventivo,
      )
    );
  }

  getEsitoPreventivoTooltip(pratica: PraticaFlowdy2_Firestore): string {
    if (pratica.statoPreventivo === "IN ATTESA") {
      return "In attesa di conferma";
    } else if (pratica.statoPreventivo === "APPROVATO") {
      return (
        "Approvato il " +
        this.utilService.formattaDataDaTimestampFirestore(
          pratica.dataEsitoPreventivo,
        )
      );
    } else {
      let tooltipRespingemnto =
        "Respinto il " +
        this.utilService.formattaDataDaTimestampFirestore(
          pratica.dataEsitoPreventivo,
        );
      if (pratica.noteRifiutoPreventivo) {
        tooltipRespingemnto +=
          " con le seguenti indicazioni: " +
          pratica.noteRifiutoPreventivo.toUpperCase();
      }
      return tooltipRespingemnto;
    }
  }

  checkSopralluogoPassato(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      pratica.dataSopralluogo &&
      pratica.statoFlowdyFase1 === "SOPRALLUOGO PIANIFICATO"
    ) {
      const oggi = new Date();
      const dataSopralluogoDaControllare = new Date(
        pratica.dataSopralluogo.toDate().getFullYear(),
        pratica.dataSopralluogo.toDate().getMonth(),
        pratica.dataSopralluogo.toDate().getDate() + 2,
      );

      if (dataSopralluogoDaControllare < oggi) {
        return true;
      }
      return false;
    }

    return false;
  }

  mostraInfo(pratica: PraticaFlowdy2_Firestore) {
    this.selectedPratica = pratica;
    this.showDettagliPratica = true;
  }
  checkIfInfoAreAvailable(pratica: PraticaFlowdy2_Firestore): boolean {
    if (pratica.sdfPrincipale || pratica.impresaFC) {
      return true;
    }
    return false;
  }

  getTooltipSopralluogoPassato(pratica: PraticaFlowdy2_Firestore): string {
    if (this.checkSopralluogoPassato(pratica)) {
      const oggi = new Date();
      const dataSopralluogo = pratica.dataSopralluogo.toDate(); // Converte il Firestore Timestamp in un oggetto Date
      const diffTime = Math.abs(oggi.getTime() - dataSopralluogo.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) - 1; // Converte il tempo in giorni
      return (
        "Sopralluogo pianificato " +
        diffDays +
        " giorni fa e di cui non si è comunicato l'esito!"
      );
    }
    return "";
  }

  getOpereExtraTooltip(pratica: PraticaFlowdy2_Firestore): string {
    if (!pratica.opereExtra) {
      return "Non necessarie";
    } else {
      return pratica.noteOpereExtra;
    }
  }
  checkInviataAdInfratel(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      pratica.codiceStatoInfratelFase1 === "1-5" ||
      pratica.codiceStatoInfratelFase1 === "1-6"
    ) {
      return true;
    }
    return false;
  }

  filtraPratiche(event: any) {
    if (event && event.target) {
      this.praticheDT.filterGlobal(event.target.value, "contains");
    } else {
      if (
        this._filtroPratiche &&
        Object.keys(this._filtroPratiche).length !== 0
      ) {
        this.filterTabellaIsSet = true;
        this.praticheFiltrate = this.praticheSenzaEscludereLeKO.filter(
          (pratica: PraticaFlowdy2_Firestore) => {
            if (
              ((this._filtroPratiche.tipo?.length ?? 0) > 0 &&
                (this._filtroPratiche.tipo.indexOf(pratica.tipoSede) == -1 &&
                  this._filtroPratiche.tipo.indexOf(
                    pratica.tipoSedeEffettiva,
                  ) == -1)) ||
              ((this._filtroPratiche.statoInfratel?.length ?? 0 > 0) &&
                this._filtroPratiche.statoInfratel.indexOf(
                  pratica.codiceStatoInfratelFase1,
                ) == -1) ||
              ((this._filtroPratiche.statoPratica?.length ?? 0 > 0) &&
                this._filtroPratiche.statoPratica.indexOf(
                  pratica.statoFlowdyFase1,
                ) == -1) ||
              ((this._filtroPratiche.regione?.length ?? 0 > 0) &&
                this._filtroPratiche.regione.indexOf(pratica.regione) == -1) ||
              //((this._filtroPratiche.impresa?.length ?? 0  > 0 ) &&  this._filtroPratiche.impresa.indexOf(pratica.idAziendaFase1) == -1  )
              ((this._filtroPratiche.impresa?.length ?? 0 > 0) &&
                this._filtroPratiche.impresa.indexOf(
                  pratica.idAziendaFase1 || pratica.idAziendaFase1,
                ) == -1)
            ) {
              return false;
            }

            return true;
          },
        );
      } else {
        this.praticheFiltrate = this.praticheSenzaEscludereLeKO;
      }
    }
  }

  filtraPerStatoInfratel(statoInfratel: string) {
    if (!this.filterTabellaIsSet) {
      this.praticheDT.filterGlobal(statoInfratel, "contains");
      this.filterTabellaIsSet = true;
    } else {
      this.praticheDT.clear();
      this.filterTabellaIsSet = false;
    }
  }

  filtraPerOda(numeroOda: number) {
    if (!this.filterTabellaIsSet) {
      this.praticheDT.filterGlobal(numeroOda, "contains");
      this.filterTabellaIsSet = true;
    } else {
      this.praticheDT.clear();
      this.filterTabellaIsSet = false;
    }
  }

  filtraPerBando(oda: OdaAtFirestore) {
    if (!this.filterTabellaIsSet) {
      this.praticheDT.filterGlobal(oda.bando, "contains");
      this.filterTabellaIsSet = true;
    } else {
      this.praticheDT.clear();
      this.filterTabellaIsSet = false;
    }
  }
  filtraPerAzienda(azienda: String) {
    if (!this.filterTabellaIsSet) {
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.praticheDT.filterGlobal(azienda, "contains");
        this.filterTabellaIsSet = true;
      }
    } else {
      this.praticheDT.clear();
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.filterTabellaIsSet = false;
        this.praticheFiltrate = this.pratiche;
      }
    }
  }

  filtraPerLotto(lotto: string) {
    // this.logger.info("-> filtraPerLotto "+ lotto);
    if (!this.filterTabellaIsSet) {
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.praticheFiltrate = this.pratiche.filter(
          (pratica: PraticaFlowdy2_Firestore) => {
            if (pratica.lotto === lotto) {
              return true;
            }
            return false;
          },
        );
        this.filterTabellaIsSet = true;
      }
    } else {
      this.praticheDT.clear();
      if (
        (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) &&
        (!this._filtroPratiche.statoInfratel ||
          !this._filtroPratiche.statoInfratel.length) &&
        (!this._filtroPratiche.regione ||
          !this._filtroPratiche.regione.length) &&
        (!this._filtroPratiche.statoPratica ||
          !this._filtroPratiche.statoPratica.length)
      ) {
        this.filterTabellaIsSet = false;
        this.praticheFiltrate = this.pratiche;
      }
    }
  }

  goBack() {
    this.logger.info("[PRATICHE FASE 1] GO BACK FROM: " + this.paginaBack);
    /* let from = 'WIP_SOPRALLUOGHI';
      if(this.filtroStatoFlowdy){
        from = 'DOCS_FASE1';
      } */
    // Naviga verso la home con i parametri per selezionare il tab corretto
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() =>
      this.router.navigate([""], {
        queryParams: {
          bando: "2", // Bando 1
          from: this.paginaBack,
        },
        queryParamsHandling: "merge",
      }),
    );
    this.removeFilter();
  }
  removeFilter() {
    if (
      this.filtroLotto ||
      this.filtroStatoInfratel ||
      this.filtroInLavorazione ||
      this.filtroOda ||
      this.filtroLottoPerFase ||
      this.filtroImpresa ||
      this.filtroPratica ||
      this.filtroRegione ||
      this.filtroStatoFlowdy
    ) {
      this.location.replaceState("/pratiche-bando2/fase-1");

      this.filterIsSet = false;
      this.filtroLotto = null;
      this.filtroStatoInfratel = null;
      this.filtroInLavorazione = null;
      this.filtroOda = null;
      this.filtroLottoPerFase = null;
      this.filtroImpresa = null;
      this.filtroStatoSopralluogo = "";
      this.ragioneSocialeImpresa = "";
      this.filtroPratica = null;
      this.filtroRegione = null;
      this.filtroStatoFlowdy = null;
      this.loadPratiche();
    } else {
      if (
        (this._filtroPratiche &&
          this._filtroPratiche.tipo &&
          this._filtroPratiche.tipo.length > 0) ||
        (this._filtroPratiche.statoInfratel &&
          this._filtroPratiche.statoInfratel.length > 0) ||
        (this._filtroPratiche.regione &&
          this._filtroPratiche.regione.length > 0) ||
        (this._filtroPratiche.statoPratica &&
          this._filtroPratiche.statoPratica.length > 0) ||
        (this._filtroPratiche.impresa &&
          this._filtroPratiche.impresa.length > 0)
      ) {
        this._filtroPratiche.tipo = [];
        this._filtroPratiche.statoInfratel = [];
        this._filtroPratiche.statoPratica = [];
        this._filtroPratiche.regione = [];
        this._filtroPratiche.impresa = [];
      }
      this.filterTabellaIsSet = false;
      this.praticheFiltrate = this.pratiche;
      this.praticheDT.clear();
    }
  }

  mostraPratiche(oda: OdaAtFirestore, fase: string) {}

  apriNoteImpresa(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogNoteImpresa, {
      data: {
        pratica: pratica,
        noteImpresa: pratica.noteSopralluogo,
      },
      header:
        "Note indicate in fase di comunicazione del sopralluogo della pratica " +
        pratica.cui.toUpperCase(),
      width: "60%",
      height: "40%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
  }

  scaricaReportPratiche() {
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, "0")}_${(today.getMonth() + 1).toString().padStart(2, "0")}_${today.getFullYear()}`;
    this.excelService.exportPraticheFase1ToExcel(
      this.pratiche,
      `pratiche_bando2_fase1_${formattedDate}.xlsx`,
      this.isImpresa,
    );
  }

  async scaricaReportPreventiviOpereExtra() {
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, "0")}_${(today.getMonth() + 1).toString().padStart(2, "0")}_${today.getFullYear()}`;
    this.isLoadingResults = true;
    const collectionRef = this.firestore.collection(
      this.collection_pratiche,
    ).ref;
    let query;
    query = collectionRef
      .where("bando", "==", "BANDO 2")
      .where("opereExtra", "==", true)
      .orderBy("statoPreventivo");
    const qs = await query.get();
    let praticheConPreventiviOpereExtra: PraticaFlowdy2_Firestore[] = [];
    qs.forEach((doc) => {
      let praticaBando2DaFirestore: PraticaFlowdy2_Firestore =
        doc.data() as PraticaFlowdy2_Firestore;
      if (praticaBando2DaFirestore.preventivo) {
        praticaBando2DaFirestore.preventivo = Number(
          praticaBando2DaFirestore.preventivo.toFixed(2),
        );
        praticheConPreventiviOpereExtra.push(praticaBando2DaFirestore);
      }
    });
    this.excelService.exportPreventiviOpereExtraToExcel(
      praticheConPreventiviOpereExtra,
      `preventivi_opere_extra_bando2_${formattedDate}.xlsx`,
    );
    this.isLoadingResults = false;
  }

  checkShowActionIcons(pratica: PraticaFlowdy2_Firestore): boolean {
    if (
      pratica.statoFlowdyFase1 === "ASSEGNATA" ||
      pratica.statoFlowdyFase1 === "SOPRALLUOGO EFFETTUATO" ||
      pratica.statoFlowdyFase1 === "RESPINTA" ||
      pratica.statoFlowdyFase1 === "IN REWORK AZIENDA" ||
      pratica.statoFlowdyFase1 === "PREVENTIVO IN ATTESA" ||
      pratica.statoFlowdyFase1 === "PREVENTIVO APPROVATO"
    ) {
      return true;
    }
    return false;
  }

  comunicaDataSopralluogo(pratica: PraticaFlowdy2_Firestore) {
    this.ref = this.dialogService.open(DialogComunicaDataSopralluogoFase1, {
      data: {
        pratica: pratica,
      },
      header:
        "Comunica data prevista per il sopralluogo della pratica " +
        pratica.cui.toUpperCase(),
      width: "50%",
      height: "25%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((confermaEsito) => {
      if (confermaEsito && confermaEsito.success) {
        this.messageService.add({
          severity: "success",
          summary: "",
          detail: "Data prevista per il sopralluogo comunicato con successo!",
          life: 3000,
        });
        this.loadPratiche();
      }
    });
  }

  /* modificaOda(oda:OdaAtFirestore){
      this.isLoadingResults = true;
      this.odaService.getById(oda.id.toString()).subscribe( {
          next: (v) => {
            // this.logger.info(JSON.stringify(v));
            this.ref = this.dialogService.open(ModificaOdaComponent, {
              data :{
                oda:v
              },
              header: "Modifica ordine di acquisto "+ oda.numero,
              width:  "60%" ,
              height: "40%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.ref.onClose.subscribe((confirmNewOda) => {
              if (confirmNewOda && confirmNewOda.success) {
                this.messageService.add({severity:'success', summary:'', detail:'Oda modificato con successo!', life:3000});
                this.loadPratiche();
              }
            });  
          },
          error: (e) => {
              this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di recupero dell\'oda da modificare azienda'});
              this.isLoadingResults = false;
          },
          complete: () => {
              this.isLoadingResults = false;
              
          }
      });
    }

    eliminaOda(oda:OdaAtFirestore){
      this.showDeleteConfirmation = true;
      this.selectedPRATICHE FASE 1 = oda;
    }

    confermaEliminazioneOda(){
      this.showDeleteConfirmation = false;
      this.isLoadingResults = true;
      this.odaService.elimina(this.selectedPRATICHE FASE 1.id.toString()).subscribe( {
          next: (v) => {
  
          },
          error: (e) => {
              this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di eliminazione dell\'ordine di acquisto'});
              this.isLoadingResults = false;
          },
          complete: () => {
              this.messageService.add({severity:'success', summary:'', detail:'Ordine di acquisto eliminato!', life:5000});
            this.loadPratiche();
              this.isLoadingResults = false;
              
          }
      });
    }
 */

  setUserRole() {
    if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "ADMIN"
    ) {
      this.isAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SUPERADMIN"
    ) {
      this.isSuperAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SMARTFIBER"
    ) {
      this.isPresidioSF = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PRESIDIO"
    ) {
      this.isPresidioTIM = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
    ) {
      this.isImpresa = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_VERBALI"
    ) {
      this.isDirigenteFirmaVerbali = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
    ) {
      this.isDirigenteFirmaPacchetti = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PM"
    ) {
      this.isPM = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DEMO"
    ) {
      this.isDemo = true;
    }
  }

  getPrincipaleDiUnaColocata(pratica: PraticaFlowdy2_Firestore): string {
    return pratica.colocataScuolaPrincipale;
  }

  getCodiceInvioColocata(pratica: PraticaFlowdy2_Firestore): string {
    return pratica.colocataScuolaPrincipale;
  }
}
